var map = {
	"./0-circle-fill.svg": [
		70394,
		[
			70394
		]
	],
	"./0-circle.svg": [
		39920,
		[
			39920
		]
	],
	"./0-square-fill.svg": [
		33293,
		[
			33293
		]
	],
	"./0-square.svg": [
		53657,
		[
			53657
		]
	],
	"./1-circle-fill.svg": [
		30067,
		[
			30067
		]
	],
	"./1-circle.svg": [
		74895,
		[
			74895
		]
	],
	"./1-square-fill.svg": [
		28720,
		[
			28720
		]
	],
	"./1-square.svg": [
		80670,
		[
			80670
		]
	],
	"./123.svg": [
		59799,
		[
			59799
		]
	],
	"./2-circle-fill.svg": [
		88160,
		[
			88160
		]
	],
	"./2-circle.svg": [
		21806,
		[
			21806
		]
	],
	"./2-square-fill.svg": [
		63087,
		[
			63087
		]
	],
	"./2-square.svg": [
		71107,
		[
			71107
		]
	],
	"./3-circle-fill.svg": [
		33721,
		[
			33721
		]
	],
	"./3-circle.svg": [
		22573,
		[
			22573
		]
	],
	"./3-square-fill.svg": [
		42410,
		[
			42410
		]
	],
	"./3-square.svg": [
		30656,
		[
			30656
		]
	],
	"./4-circle-fill.svg": [
		58081,
		[
			80462
		]
	],
	"./4-circle.svg": [
		47516,
		[
			47516
		]
	],
	"./4-square-fill.svg": [
		7457,
		[
			7457
		]
	],
	"./4-square.svg": [
		2277,
		[
			2277
		]
	],
	"./5-circle-fill.svg": [
		42343,
		[
			42343
		]
	],
	"./5-circle.svg": [
		37515,
		[
			37515
		]
	],
	"./5-square-fill.svg": [
		25316,
		[
			25316
		]
	],
	"./5-square.svg": [
		97098,
		[
			97098
		]
	],
	"./6-circle-fill.svg": [
		29044,
		[
			29044
		]
	],
	"./6-circle.svg": [
		47930,
		[
			47930
		]
	],
	"./6-square-fill.svg": [
		82307,
		[
			82307
		]
	],
	"./6-square.svg": [
		58175,
		[
			58175
		]
	],
	"./7-circle-fill.svg": [
		56461,
		[
			56461
		]
	],
	"./7-circle.svg": [
		80729,
		[
			80729
		]
	],
	"./7-square-fill.svg": [
		32782,
		[
			32782
		]
	],
	"./7-square.svg": [
		96732,
		[
			96732
		]
	],
	"./8-circle-fill.svg": [
		8034,
		[
			8034
		]
	],
	"./8-circle.svg": [
		45992,
		[
			45992
		]
	],
	"./8-square-fill.svg": [
		31957,
		[
			31957
		]
	],
	"./8-square.svg": [
		99473,
		[
			99473
		]
	],
	"./9-circle-fill.svg": [
		57787,
		[
			57787
		]
	],
	"./9-circle.svg": [
		17895,
		[
			17895
		]
	],
	"./9-square-fill.svg": [
		78232,
		[
			78232
		]
	],
	"./9-square.svg": [
		5334,
		[
			5334
		]
	],
	"./activity.svg": [
		62662,
		[
			62662
		]
	],
	"./airplane-engines-fill.svg": [
		76021,
		[
			76021
		]
	],
	"./airplane-engines.svg": [
		34225,
		[
			34225
		]
	],
	"./airplane-fill.svg": [
		56091,
		[
			56091
		]
	],
	"./airplane.svg": [
		59463,
		[
			59463
		]
	],
	"./alarm-fill.svg": [
		79802,
		[
			79802
		]
	],
	"./alarm.svg": [
		95952,
		[
			95952
		]
	],
	"./alexa.svg": [
		21594,
		[
			21594
		]
	],
	"./align-bottom.svg": [
		58128,
		[
			58128
		]
	],
	"./align-center.svg": [
		95358,
		[
			95358
		]
	],
	"./align-end.svg": [
		71548,
		[
			71548
		]
	],
	"./align-middle.svg": [
		46609,
		[
			46609
		]
	],
	"./align-start.svg": [
		74207,
		[
			74207
		]
	],
	"./align-top.svg": [
		82986,
		[
			82986
		]
	],
	"./alipay.svg": [
		81187,
		[
			81187
		]
	],
	"./alphabet-uppercase.svg": [
		82299,
		[
			82299
		]
	],
	"./alphabet.svg": [
		48972,
		[
			48972
		]
	],
	"./alt.svg": [
		81514,
		[
			81514
		]
	],
	"./amazon.svg": [
		15605,
		[
			15605
		]
	],
	"./amd.svg": [
		95405,
		[
			95405
		]
	],
	"./android.svg": [
		91990,
		[
			91990
		]
	],
	"./android2.svg": [
		60792,
		[
			60792
		]
	],
	"./anthropic.svg": [
		40719,
		[
			40719
		]
	],
	"./app-indicator.svg": [
		62254,
		[
			62254
		]
	],
	"./app.svg": [
		16578,
		[
			16578
		]
	],
	"./apple-music.svg": [
		42285,
		[
			42285
		]
	],
	"./apple.svg": [
		72603,
		[
			72603
		]
	],
	"./archive-fill.svg": [
		29629,
		[
			29629
		]
	],
	"./archive.svg": [
		55305,
		[
			55305
		]
	],
	"./arrow-90deg-down.svg": [
		97439,
		[
			97439
		]
	],
	"./arrow-90deg-left.svg": [
		70144,
		[
			70144
		]
	],
	"./arrow-90deg-right.svg": [
		54767,
		[
			54767
		]
	],
	"./arrow-90deg-up.svg": [
		82384,
		[
			82384
		]
	],
	"./arrow-bar-down.svg": [
		12353,
		[
			12353
		]
	],
	"./arrow-bar-left.svg": [
		87546,
		[
			87546
		]
	],
	"./arrow-bar-right.svg": [
		55793,
		[
			55793
		]
	],
	"./arrow-bar-up.svg": [
		44478,
		[
			44478
		]
	],
	"./arrow-clockwise.svg": [
		86409,
		[
			86409
		]
	],
	"./arrow-counterclockwise.svg": [
		32371,
		[
			32371
		]
	],
	"./arrow-down-circle-fill.svg": [
		57864,
		[
			57864
		]
	],
	"./arrow-down-circle.svg": [
		82342,
		[
			82342
		]
	],
	"./arrow-down-left-circle-fill.svg": [
		46804,
		[
			46804
		]
	],
	"./arrow-down-left-circle.svg": [
		34874,
		[
			34874
		]
	],
	"./arrow-down-left-square-fill.svg": [
		6339,
		[
			6339
		]
	],
	"./arrow-down-left-square.svg": [
		91007,
		[
			91007
		]
	],
	"./arrow-down-left.svg": [
		30125,
		[
			30125
		]
	],
	"./arrow-down-right-circle-fill.svg": [
		32553,
		[
			32553
		]
	],
	"./arrow-down-right-circle.svg": [
		27997,
		[
			27997
		]
	],
	"./arrow-down-right-square-fill.svg": [
		24922,
		[
			24922
		]
	],
	"./arrow-down-right-square.svg": [
		21680,
		[
			21680
		]
	],
	"./arrow-down-right.svg": [
		34064,
		[
			34064
		]
	],
	"./arrow-down-short.svg": [
		24500,
		[
			24500
		]
	],
	"./arrow-down-square-fill.svg": [
		48663,
		[
			48663
		]
	],
	"./arrow-down-square.svg": [
		21179,
		[
			21179
		]
	],
	"./arrow-down-up.svg": [
		80285,
		[
			80285
		]
	],
	"./arrow-down.svg": [
		56777,
		[
			56777
		]
	],
	"./arrow-left-circle-fill.svg": [
		2307,
		[
			2307
		]
	],
	"./arrow-left-circle.svg": [
		97663,
		[
			97663
		]
	],
	"./arrow-left-right.svg": [
		1011,
		[
			1011
		]
	],
	"./arrow-left-short.svg": [
		82083,
		[
			82083
		]
	],
	"./arrow-left-square-fill.svg": [
		65856,
		[
			65856
		]
	],
	"./arrow-left-square.svg": [
		97582,
		[
			97582
		]
	],
	"./arrow-left.svg": [
		1362,
		[
			1362
		]
	],
	"./arrow-repeat.svg": [
		74520,
		[
			74520
		]
	],
	"./arrow-return-left.svg": [
		4459,
		[
			4459
		]
	],
	"./arrow-return-right.svg": [
		46382,
		[
			46382
		]
	],
	"./arrow-right-circle-fill.svg": [
		16040,
		[
			16040
		]
	],
	"./arrow-right-circle.svg": [
		91014,
		[
			91014
		]
	],
	"./arrow-right-short.svg": [
		27412,
		[
			27412
		]
	],
	"./arrow-right-square-fill.svg": [
		58327,
		[
			58327
		]
	],
	"./arrow-right-square.svg": [
		85755,
		[
			85755
		]
	],
	"./arrow-right.svg": [
		81769,
		[
			81769
		]
	],
	"./arrow-through-heart-fill.svg": [
		96959,
		[
			96959
		]
	],
	"./arrow-through-heart.svg": [
		2835,
		[
			2835
		]
	],
	"./arrow-up-circle-fill.svg": [
		33423,
		[
			33423
		]
	],
	"./arrow-up-circle.svg": [
		20835,
		[
			20835
		]
	],
	"./arrow-up-left-circle-fill.svg": [
		26473,
		[
			26473
		]
	],
	"./arrow-up-left-circle.svg": [
		89917,
		[
			89917
		]
	],
	"./arrow-up-left-square-fill.svg": [
		19482,
		[
			19482
		]
	],
	"./arrow-up-left-square.svg": [
		30704,
		[
			30704
		]
	],
	"./arrow-up-left.svg": [
		29104,
		[
			29104
		]
	],
	"./arrow-up-right-circle-fill.svg": [
		78638,
		[
			78638
		]
	],
	"./arrow-up-right-circle.svg": [
		12316,
		[
			12316
		]
	],
	"./arrow-up-right-square-fill.svg": [
		53057,
		[
			53057
		]
	],
	"./arrow-up-right-square.svg": [
		75717,
		[
			75717
		]
	],
	"./arrow-up-right.svg": [
		98527,
		[
			98527
		]
	],
	"./arrow-up-short.svg": [
		73519,
		[
			73519
		]
	],
	"./arrow-up-square-fill.svg": [
		77740,
		[
			77740
		]
	],
	"./arrow-up-square.svg": [
		57986,
		[
			57986
		]
	],
	"./arrow-up.svg": [
		10886,
		[
			10886
		]
	],
	"./arrows-angle-contract.svg": [
		48660,
		[
			48660
		]
	],
	"./arrows-angle-expand.svg": [
		9326,
		[
			9326
		]
	],
	"./arrows-collapse-vertical.svg": [
		81336,
		[
			81336
		]
	],
	"./arrows-collapse.svg": [
		65513,
		[
			65513
		]
	],
	"./arrows-expand-vertical.svg": [
		82439,
		[
			82439
		]
	],
	"./arrows-expand.svg": [
		75204,
		[
			75204
		]
	],
	"./arrows-fullscreen.svg": [
		45095,
		[
			45095
		]
	],
	"./arrows-move.svg": [
		81035,
		[
			81035
		]
	],
	"./arrows-vertical.svg": [
		698,
		[
			698
		]
	],
	"./arrows.svg": [
		47643,
		[
			47643
		]
	],
	"./aspect-ratio-fill.svg": [
		49531,
		[
			49531
		]
	],
	"./aspect-ratio.svg": [
		47431,
		[
			47431
		]
	],
	"./asterisk.svg": [
		82525,
		[
			82525
		]
	],
	"./at.svg": [
		61442,
		[
			61442
		]
	],
	"./award-fill.svg": [
		98514,
		[
			98514
		]
	],
	"./award.svg": [
		34104,
		[
			34104
		]
	],
	"./back.svg": [
		13084,
		[
			13084
		]
	],
	"./backpack-fill.svg": [
		64283,
		[
			64283
		]
	],
	"./backpack.svg": [
		5383,
		[
			5383
		]
	],
	"./backpack2-fill.svg": [
		3579,
		[
			3579
		]
	],
	"./backpack2.svg": [
		36327,
		[
			36327
		]
	],
	"./backpack3-fill.svg": [
		40536,
		[
			40536
		]
	],
	"./backpack3.svg": [
		89462,
		[
			89462
		]
	],
	"./backpack4-fill.svg": [
		25037,
		[
			25037
		]
	],
	"./backpack4.svg": [
		29945,
		[
			29945
		]
	],
	"./backspace-fill.svg": [
		77072,
		[
			77072
		]
	],
	"./backspace-reverse-fill.svg": [
		83579,
		[
			83579
		]
	],
	"./backspace-reverse.svg": [
		62439,
		[
			62439
		]
	],
	"./backspace.svg": [
		76894,
		[
			76894
		]
	],
	"./badge-3d-fill.svg": [
		26408,
		[
			26408
		]
	],
	"./badge-3d.svg": [
		17030,
		[
			17030
		]
	],
	"./badge-4k-fill.svg": [
		30762,
		[
			30762
		]
	],
	"./badge-4k.svg": [
		93107,
		[
			70726
		]
	],
	"./badge-8k-fill.svg": [
		66798,
		[
			66798
		]
	],
	"./badge-8k.svg": [
		11676,
		[
			11676
		]
	],
	"./badge-ad-fill.svg": [
		50554,
		[
			50554
		]
	],
	"./badge-ad.svg": [
		30384,
		[
			30384
		]
	],
	"./badge-ar-fill.svg": [
		82784,
		[
			82784
		]
	],
	"./badge-ar.svg": [
		9454,
		[
			9454
		]
	],
	"./badge-cc-fill.svg": [
		28909,
		[
			28909
		]
	],
	"./badge-cc.svg": [
		70585,
		[
			70585
		]
	],
	"./badge-hd-fill.svg": [
		74279,
		[
			74279
		]
	],
	"./badge-hd.svg": [
		95403,
		[
			95403
		]
	],
	"./badge-sd-fill.svg": [
		84552,
		[
			84552
		]
	],
	"./badge-sd.svg": [
		29126,
		[
			29126
		]
	],
	"./badge-tm-fill.svg": [
		86592,
		[
			86592
		]
	],
	"./badge-tm.svg": [
		30638,
		[
			30638
		]
	],
	"./badge-vo-fill.svg": [
		12152,
		[
			12152
		]
	],
	"./badge-vo.svg": [
		92630,
		[
			92630
		]
	],
	"./badge-vr-fill.svg": [
		81503,
		[
			81503
		]
	],
	"./badge-vr.svg": [
		23027,
		[
			23027
		]
	],
	"./badge-wc-fill.svg": [
		71953,
		[
			71953
		]
	],
	"./badge-wc.svg": [
		76437,
		[
			76437
		]
	],
	"./bag-check-fill.svg": [
		23432,
		[
			23432
		]
	],
	"./bag-check.svg": [
		13030,
		[
			13030
		]
	],
	"./bag-dash-fill.svg": [
		93944,
		[
			93944
		]
	],
	"./bag-dash.svg": [
		57238,
		[
			57238
		]
	],
	"./bag-fill.svg": [
		31125,
		[
			31125
		]
	],
	"./bag-heart-fill.svg": [
		90740,
		[
			90740
		]
	],
	"./bag-heart.svg": [
		97690,
		[
			97690
		]
	],
	"./bag-plus-fill.svg": [
		57108,
		[
			57108
		]
	],
	"./bag-plus.svg": [
		46170,
		[
			46170
		]
	],
	"./bag-x-fill.svg": [
		84684,
		[
			84684
		]
	],
	"./bag-x.svg": [
		80098,
		[
			80098
		]
	],
	"./bag.svg": [
		40529,
		[
			40529
		]
	],
	"./balloon-fill.svg": [
		57372,
		[
			57372
		]
	],
	"./balloon-heart-fill.svg": [
		26721,
		[
			26721
		]
	],
	"./balloon-heart.svg": [
		99653,
		[
			99653
		]
	],
	"./balloon.svg": [
		49554,
		[
			49554
		]
	],
	"./ban-fill.svg": [
		21554,
		[
			21554
		]
	],
	"./ban.svg": [
		33400,
		[
			33400
		]
	],
	"./bandaid-fill.svg": [
		7664,
		[
			7664
		]
	],
	"./bandaid.svg": [
		89054,
		[
			89054
		]
	],
	"./bank.svg": [
		29795,
		[
			29795
		]
	],
	"./bank2.svg": [
		96827,
		[
			96827
		]
	],
	"./bar-chart-fill.svg": [
		44059,
		[
			44059
		]
	],
	"./bar-chart-line-fill.svg": [
		41720,
		[
			41720
		]
	],
	"./bar-chart-line.svg": [
		45942,
		[
			45942
		]
	],
	"./bar-chart-steps.svg": [
		18593,
		[
			18593
		]
	],
	"./bar-chart.svg": [
		26215,
		[
			26215
		]
	],
	"./basket-fill.svg": [
		72923,
		[
			72923
		]
	],
	"./basket.svg": [
		90695,
		[
			90695
		]
	],
	"./basket2-fill.svg": [
		35931,
		[
			35931
		]
	],
	"./basket2.svg": [
		37255,
		[
			37255
		]
	],
	"./basket3-fill.svg": [
		51000,
		[
			51000
		]
	],
	"./basket3.svg": [
		50134,
		[
			50134
		]
	],
	"./battery-charging.svg": [
		4056,
		[
			4056
		]
	],
	"./battery-full.svg": [
		3494,
		[
			3494
		]
	],
	"./battery-half.svg": [
		31758,
		[
			31758
		]
	],
	"./battery-low.svg": [
		49757,
		[
			49757
		]
	],
	"./battery.svg": [
		45400,
		[
			45400
		]
	],
	"./beaker-fill.svg": [
		65127,
		[
			65127
		]
	],
	"./beaker.svg": [
		20171,
		[
			20171
		]
	],
	"./behance.svg": [
		57467,
		[
			57467
		]
	],
	"./bell-fill.svg": [
		82448,
		[
			82448
		]
	],
	"./bell-slash-fill.svg": [
		24864,
		[
			24864
		]
	],
	"./bell-slash.svg": [
		78446,
		[
			78446
		]
	],
	"./bell.svg": [
		90910,
		[
			90910
		]
	],
	"./bezier.svg": [
		25600,
		[
			25600
		]
	],
	"./bezier2.svg": [
		25138,
		[
			25138
		]
	],
	"./bicycle.svg": [
		15792,
		[
			15792
		]
	],
	"./bing.svg": [
		35887,
		[
			35887
		]
	],
	"./binoculars-fill.svg": [
		9467,
		[
			9467
		]
	],
	"./binoculars.svg": [
		15559,
		[
			15559
		]
	],
	"./blockquote-left.svg": [
		33554,
		[
			33554
		]
	],
	"./blockquote-right.svg": [
		66473,
		[
			66473
		]
	],
	"./bluesky.svg": [
		95012,
		[
			95012
		]
	],
	"./bluetooth.svg": [
		17841,
		[
			17841
		]
	],
	"./body-text.svg": [
		65155,
		[
			65155
		]
	],
	"./book-fill.svg": [
		89348,
		[
			89348
		]
	],
	"./book-half.svg": [
		52008,
		[
			52008
		]
	],
	"./book.svg": [
		36586,
		[
			36586
		]
	],
	"./bookmark-check-fill.svg": [
		6172,
		[
			6172
		]
	],
	"./bookmark-check.svg": [
		80242,
		[
			57861
		]
	],
	"./bookmark-dash-fill.svg": [
		98852,
		[
			76471
		]
	],
	"./bookmark-dash.svg": [
		63434,
		[
			63434
		]
	],
	"./bookmark-fill.svg": [
		58009,
		[
			58009
		]
	],
	"./bookmark-heart-fill.svg": [
		8656,
		[
			8656
		]
	],
	"./bookmark-heart.svg": [
		50590,
		[
			50590
		]
	],
	"./bookmark-plus-fill.svg": [
		99304,
		[
			99304
		]
	],
	"./bookmark-plus.svg": [
		37830,
		[
			37830
		]
	],
	"./bookmark-star-fill.svg": [
		65004,
		[
			65004
		]
	],
	"./bookmark-star.svg": [
		52450,
		[
			52450
		]
	],
	"./bookmark-x-fill.svg": [
		42760,
		[
			42760
		]
	],
	"./bookmark-x.svg": [
		40966,
		[
			40966
		]
	],
	"./bookmark.svg": [
		49485,
		[
			49485
		]
	],
	"./bookmarks-fill.svg": [
		60774,
		[
			60774
		]
	],
	"./bookmarks.svg": [
		75428,
		[
			75428
		]
	],
	"./bookshelf.svg": [
		99354,
		[
			99354
		]
	],
	"./boombox-fill.svg": [
		29003,
		[
			29003
		]
	],
	"./boombox.svg": [
		40855,
		[
			40855
		]
	],
	"./bootstrap-fill.svg": [
		57193,
		[
			57193
		]
	],
	"./bootstrap-reboot.svg": [
		96789,
		[
			96789
		]
	],
	"./bootstrap.svg": [
		44413,
		[
			44413
		]
	],
	"./border-all.svg": [
		83705,
		[
			83705
		]
	],
	"./border-bottom.svg": [
		72169,
		[
			72169
		]
	],
	"./border-center.svg": [
		63611,
		[
			63611
		]
	],
	"./border-inner.svg": [
		44312,
		[
			44312
		]
	],
	"./border-left.svg": [
		3619,
		[
			3619
		]
	],
	"./border-middle.svg": [
		34087,
		[
			34087
		]
	],
	"./border-outer.svg": [
		27721,
		[
			27721
		]
	],
	"./border-right.svg": [
		24710,
		[
			24710
		]
	],
	"./border-style.svg": [
		56071,
		[
			56071
		]
	],
	"./border-top.svg": [
		52305,
		[
			52305
		]
	],
	"./border-width.svg": [
		97396,
		[
			97396
		]
	],
	"./border.svg": [
		67807,
		[
			67807
		]
	],
	"./bounding-box-circles.svg": [
		13017,
		[
			13017
		]
	],
	"./bounding-box.svg": [
		47529,
		[
			47529
		]
	],
	"./box-arrow-down-left.svg": [
		24837,
		[
			24837
		]
	],
	"./box-arrow-down-right.svg": [
		68904,
		[
			68904
		]
	],
	"./box-arrow-down.svg": [
		14449,
		[
			14449
		]
	],
	"./box-arrow-in-down-left.svg": [
		18113,
		[
			18113
		]
	],
	"./box-arrow-in-down-right.svg": [
		66220,
		[
			66220
		]
	],
	"./box-arrow-in-down.svg": [
		22653,
		[
			22653
		]
	],
	"./box-arrow-in-left.svg": [
		25030,
		[
			25030
		]
	],
	"./box-arrow-in-right.svg": [
		31621,
		[
			31621
		]
	],
	"./box-arrow-in-up-left.svg": [
		17148,
		[
			17148
		]
	],
	"./box-arrow-in-up-right.svg": [
		79715,
		[
			79715
		]
	],
	"./box-arrow-in-up.svg": [
		90018,
		[
			90018
		]
	],
	"./box-arrow-left.svg": [
		12714,
		[
			12714
		]
	],
	"./box-arrow-right.svg": [
		99649,
		[
			99649
		]
	],
	"./box-arrow-up-left.svg": [
		86088,
		[
			86088
		]
	],
	"./box-arrow-up-right.svg": [
		951,
		[
			951
		]
	],
	"./box-arrow-up.svg": [
		60622,
		[
			60622
		]
	],
	"./box-fill.svg": [
		43862,
		[
			43862
		]
	],
	"./box-seam-fill.svg": [
		47131,
		[
			47131
		]
	],
	"./box-seam.svg": [
		38311,
		[
			38311
		]
	],
	"./box.svg": [
		45524,
		[
			45524
		]
	],
	"./box2-fill.svg": [
		27072,
		[
			27072
		]
	],
	"./box2-heart-fill.svg": [
		2813,
		[
			2813
		]
	],
	"./box2-heart.svg": [
		82057,
		[
			82057
		]
	],
	"./box2.svg": [
		23022,
		[
			23022
		]
	],
	"./boxes.svg": [
		16080,
		[
			16080
		]
	],
	"./braces-asterisk.svg": [
		70846,
		[
			70846
		]
	],
	"./braces.svg": [
		13269,
		[
			13269
		]
	],
	"./bricks.svg": [
		51215,
		[
			51215
		]
	],
	"./briefcase-fill.svg": [
		82215,
		[
			82215
		]
	],
	"./briefcase.svg": [
		22955,
		[
			22955
		]
	],
	"./brightness-alt-high-fill.svg": [
		97555,
		[
			97555
		]
	],
	"./brightness-alt-high.svg": [
		32015,
		[
			32015
		]
	],
	"./brightness-alt-low-fill.svg": [
		93855,
		[
			93855
		]
	],
	"./brightness-alt-low.svg": [
		3923,
		[
			3923
		]
	],
	"./brightness-high-fill.svg": [
		53637,
		[
			53637
		]
	],
	"./brightness-high.svg": [
		73729,
		[
			73729
		]
	],
	"./brightness-low-fill.svg": [
		95785,
		[
			95785
		]
	],
	"./brightness-low.svg": [
		24445,
		[
			24445
		]
	],
	"./brilliance.svg": [
		6602,
		[
			6602
		]
	],
	"./broadcast-pin.svg": [
		47612,
		[
			47612
		]
	],
	"./broadcast.svg": [
		30494,
		[
			30494
		]
	],
	"./browser-chrome.svg": [
		51530,
		[
			51530
		]
	],
	"./browser-edge.svg": [
		99803,
		[
			99803
		]
	],
	"./browser-firefox.svg": [
		80759,
		[
			80759
		]
	],
	"./browser-safari.svg": [
		22756,
		[
			22756
		]
	],
	"./brush-fill.svg": [
		59879,
		[
			59879
		]
	],
	"./brush.svg": [
		92203,
		[
			92203
		]
	],
	"./bucket-fill.svg": [
		47391,
		[
			47391
		]
	],
	"./bucket.svg": [
		19955,
		[
			19955
		]
	],
	"./bug-fill.svg": [
		23961,
		[
			23961
		]
	],
	"./bug.svg": [
		35373,
		[
			35373
		]
	],
	"./building-add.svg": [
		49047,
		[
			49047
		]
	],
	"./building-check.svg": [
		66442,
		[
			66442
		]
	],
	"./building-dash.svg": [
		49026,
		[
			49026
		]
	],
	"./building-down.svg": [
		86242,
		[
			86242
		]
	],
	"./building-exclamation.svg": [
		71917,
		[
			71917
		]
	],
	"./building-fill-add.svg": [
		4443,
		[
			4443
		]
	],
	"./building-fill-check.svg": [
		11782,
		[
			11782
		]
	],
	"./building-fill-dash.svg": [
		40054,
		[
			40054
		]
	],
	"./building-fill-down.svg": [
		23662,
		[
			23662
		]
	],
	"./building-fill-exclamation.svg": [
		39217,
		[
			39217
		]
	],
	"./building-fill-gear.svg": [
		72559,
		[
			72559
		]
	],
	"./building-fill-lock.svg": [
		59119,
		[
			59119
		]
	],
	"./building-fill-slash.svg": [
		72493,
		[
			72493
		]
	],
	"./building-fill-up.svg": [
		29733,
		[
			29733
		]
	],
	"./building-fill-x.svg": [
		95842,
		[
			95842
		]
	],
	"./building-fill.svg": [
		27569,
		[
			27569
		]
	],
	"./building-gear.svg": [
		20899,
		[
			20899
		]
	],
	"./building-lock.svg": [
		71283,
		[
			71283
		]
	],
	"./building-slash.svg": [
		82321,
		[
			82321
		]
	],
	"./building-up.svg": [
		91217,
		[
			91217
		]
	],
	"./building-x.svg": [
		79758,
		[
			79758
		]
	],
	"./building.svg": [
		30773,
		[
			30773
		]
	],
	"./buildings-fill.svg": [
		56238,
		[
			56238
		]
	],
	"./buildings.svg": [
		23868,
		[
			23868
		]
	],
	"./bullseye.svg": [
		84716,
		[
			84716
		]
	],
	"./bus-front-fill.svg": [
		91019,
		[
			91019
		]
	],
	"./bus-front.svg": [
		53623,
		[
			53623
		]
	],
	"./c-circle-fill.svg": [
		11113,
		[
			11113
		]
	],
	"./c-circle.svg": [
		48573,
		[
			48573
		]
	],
	"./c-square-fill.svg": [
		3482,
		[
			3482
		]
	],
	"./c-square.svg": [
		42256,
		[
			42256
		]
	],
	"./cake-fill.svg": [
		25905,
		[
			25905
		]
	],
	"./cake.svg": [
		63093,
		[
			63093
		]
	],
	"./cake2-fill.svg": [
		85705,
		[
			85705
		]
	],
	"./cake2.svg": [
		78557,
		[
			78557
		]
	],
	"./calculator-fill.svg": [
		67293,
		[
			67293
		]
	],
	"./calculator.svg": [
		45225,
		[
			45225
		]
	],
	"./calendar-check-fill.svg": [
		24974,
		[
			24974
		]
	],
	"./calendar-check.svg": [
		20092,
		[
			20092
		]
	],
	"./calendar-date-fill.svg": [
		51930,
		[
			29549
		]
	],
	"./calendar-date.svg": [
		98832,
		[
			98832
		]
	],
	"./calendar-day-fill.svg": [
		61412,
		[
			61412
		]
	],
	"./calendar-day.svg": [
		2122,
		[
			2122
		]
	],
	"./calendar-event-fill.svg": [
		64158,
		[
			64158
		]
	],
	"./calendar-event.svg": [
		47468,
		[
			47468
		]
	],
	"./calendar-fill.svg": [
		44359,
		[
			44359
		]
	],
	"./calendar-heart-fill.svg": [
		65106,
		[
			65106
		]
	],
	"./calendar-heart.svg": [
		2200,
		[
			2200
		]
	],
	"./calendar-minus-fill.svg": [
		54478,
		[
			54478
		]
	],
	"./calendar-minus.svg": [
		3548,
		[
			3548
		]
	],
	"./calendar-month-fill.svg": [
		35208,
		[
			35208
		]
	],
	"./calendar-month.svg": [
		73318,
		[
			73318
		]
	],
	"./calendar-plus-fill.svg": [
		58230,
		[
			58230
		]
	],
	"./calendar-plus.svg": [
		13140,
		[
			13140
		]
	],
	"./calendar-range-fill.svg": [
		5919,
		[
			5919
		]
	],
	"./calendar-range.svg": [
		1363,
		[
			1363
		]
	],
	"./calendar-week-fill.svg": [
		25682,
		[
			25682
		]
	],
	"./calendar-week.svg": [
		95320,
		[
			95320
		]
	],
	"./calendar-x-fill.svg": [
		69478,
		[
			69478
		]
	],
	"./calendar-x.svg": [
		5028,
		[
			5028
		]
	],
	"./calendar.svg": [
		90891,
		[
			90891
		]
	],
	"./calendar2-check-fill.svg": [
		79862,
		[
			73833
		]
	],
	"./calendar2-check.svg": [
		30164,
		[
			30164
		]
	],
	"./calendar2-date-fill.svg": [
		9042,
		[
			9042
		]
	],
	"./calendar2-date.svg": [
		53656,
		[
			53656
		]
	],
	"./calendar2-day-fill.svg": [
		43900,
		[
			43900
		]
	],
	"./calendar2-day.svg": [
		29074,
		[
			29074
		]
	],
	"./calendar2-event-fill.svg": [
		24598,
		[
			24598
		]
	],
	"./calendar2-event.svg": [
		7188,
		[
			7188
		]
	],
	"./calendar2-fill.svg": [
		68031,
		[
			68031
		]
	],
	"./calendar2-heart-fill.svg": [
		82922,
		[
			82922
		]
	],
	"./calendar2-heart.svg": [
		75264,
		[
			75264
		]
	],
	"./calendar2-minus-fill.svg": [
		36294,
		[
			36294
		]
	],
	"./calendar2-minus.svg": [
		76228,
		[
			76228
		]
	],
	"./calendar2-month-fill.svg": [
		48592,
		[
			48592
		]
	],
	"./calendar2-month.svg": [
		99518,
		[
			99518
		]
	],
	"./calendar2-plus-fill.svg": [
		61246,
		[
			61246
		]
	],
	"./calendar2-plus.svg": [
		62604,
		[
			62604
		]
	],
	"./calendar2-range-fill.svg": [
		28727,
		[
			28727
		]
	],
	"./calendar2-range.svg": [
		8315,
		[
			8315
		]
	],
	"./calendar2-week-fill.svg": [
		50170,
		[
			50170
		]
	],
	"./calendar2-week.svg": [
		7760,
		[
			7760
		]
	],
	"./calendar2-x-fill.svg": [
		76574,
		[
			76574
		]
	],
	"./calendar2-x.svg": [
		4556,
		[
			4556
		]
	],
	"./calendar2.svg": [
		56435,
		[
			56435
		]
	],
	"./calendar3-event-fill.svg": [
		14973,
		[
			14973
		]
	],
	"./calendar3-event.svg": [
		94761,
		[
			94761
		]
	],
	"./calendar3-fill.svg": [
		22444,
		[
			22444
		]
	],
	"./calendar3-range-fill.svg": [
		24628,
		[
			24628
		]
	],
	"./calendar3-range.svg": [
		86586,
		[
			86586
		]
	],
	"./calendar3-week-fill.svg": [
		98071,
		[
			98071
		]
	],
	"./calendar3-week.svg": [
		25960,
		[
			25960
		]
	],
	"./calendar3.svg": [
		34914,
		[
			34914
		]
	],
	"./calendar4-event.svg": [
		3838,
		[
			3838
		]
	],
	"./calendar4-range.svg": [
		20641,
		[
			20641
		]
	],
	"./calendar4-week.svg": [
		26054,
		[
			26054
		]
	],
	"./calendar4.svg": [
		5133,
		[
			5133
		]
	],
	"./camera-fill.svg": [
		39382,
		[
			39382
		]
	],
	"./camera-reels-fill.svg": [
		85914,
		[
			85914
		]
	],
	"./camera-reels.svg": [
		80368,
		[
			80368
		]
	],
	"./camera-video-fill.svg": [
		80844,
		[
			80844
		]
	],
	"./camera-video-off-fill.svg": [
		99516,
		[
			99516
		]
	],
	"./camera-video-off.svg": [
		78981,
		[
			78981
		]
	],
	"./camera-video.svg": [
		17282,
		[
			17282
		]
	],
	"./camera.svg": [
		79444,
		[
			79444
		]
	],
	"./camera2.svg": [
		73486,
		[
			73486
		]
	],
	"./capslock-fill.svg": [
		80783,
		[
			80783
		]
	],
	"./capslock.svg": [
		22947,
		[
			22947
		]
	],
	"./capsule-pill.svg": [
		78602,
		[
			78602
		]
	],
	"./capsule.svg": [
		17362,
		[
			17362
		]
	],
	"./car-front-fill.svg": [
		11531,
		[
			11531
		]
	],
	"./car-front.svg": [
		37143,
		[
			37143
		]
	],
	"./card-checklist.svg": [
		99163,
		[
			21544
		]
	],
	"./card-heading.svg": [
		88018,
		[
			65637
		]
	],
	"./card-image.svg": [
		83455,
		[
			83455
		]
	],
	"./card-list.svg": [
		16896,
		[
			16896
		]
	],
	"./card-text.svg": [
		29677,
		[
			29677
		]
	],
	"./caret-down-fill.svg": [
		49963,
		[
			49963
		]
	],
	"./caret-down-square-fill.svg": [
		59497,
		[
			59497
		]
	],
	"./caret-down-square.svg": [
		44893,
		[
			44893
		]
	],
	"./caret-down.svg": [
		50455,
		[
			50455
		]
	],
	"./caret-left-fill.svg": [
		17858,
		[
			17858
		]
	],
	"./caret-left-square-fill.svg": [
		55874,
		[
			55874
		]
	],
	"./caret-left-square.svg": [
		21960,
		[
			21960
		]
	],
	"./caret-left.svg": [
		19656,
		[
			19656
		]
	],
	"./caret-right-fill.svg": [
		43531,
		[
			43531
		]
	],
	"./caret-right-square-fill.svg": [
		67593,
		[
			67593
		]
	],
	"./caret-right-square.svg": [
		62877,
		[
			62877
		]
	],
	"./caret-right.svg": [
		89655,
		[
			89655
		]
	],
	"./caret-up-fill.svg": [
		1346,
		[
			1346
		]
	],
	"./caret-up-square-fill.svg": [
		59202,
		[
			59202
		]
	],
	"./caret-up-square.svg": [
		43496,
		[
			43496
		]
	],
	"./caret-up.svg": [
		4808,
		[
			4808
		]
	],
	"./cart-check-fill.svg": [
		44282,
		[
			44282
		]
	],
	"./cart-check.svg": [
		35408,
		[
			35408
		]
	],
	"./cart-dash-fill.svg": [
		43206,
		[
			43206
		]
	],
	"./cart-dash.svg": [
		85604,
		[
			85604
		]
	],
	"./cart-fill.svg": [
		89203,
		[
			89203
		]
	],
	"./cart-plus-fill.svg": [
		37202,
		[
			37202
		]
	],
	"./cart-plus.svg": [
		98968,
		[
			98968
		]
	],
	"./cart-x-fill.svg": [
		71066,
		[
			71066
		]
	],
	"./cart-x.svg": [
		35248,
		[
			35248
		]
	],
	"./cart.svg": [
		71439,
		[
			71439
		]
	],
	"./cart2.svg": [
		71711,
		[
			71711
		]
	],
	"./cart3.svg": [
		66958,
		[
			66958
		]
	],
	"./cart4.svg": [
		92305,
		[
			92305
		]
	],
	"./cash-coin.svg": [
		70398,
		[
			70398
		]
	],
	"./cash-stack.svg": [
		9035,
		[
			9035
		]
	],
	"./cash.svg": [
		67784,
		[
			67784
		]
	],
	"./cassette-fill.svg": [
		58125,
		[
			58125
		]
	],
	"./cassette.svg": [
		78745,
		[
			78745
		]
	],
	"./cast.svg": [
		39500,
		[
			39500
		]
	],
	"./cc-circle-fill.svg": [
		906,
		[
			906
		]
	],
	"./cc-circle.svg": [
		78048,
		[
			78048
		]
	],
	"./cc-square-fill.svg": [
		88541,
		[
			88541
		]
	],
	"./cc-square.svg": [
		26665,
		[
			26665
		]
	],
	"./chat-dots-fill.svg": [
		32798,
		[
			32798
		]
	],
	"./chat-dots.svg": [
		52748,
		[
			52748
		]
	],
	"./chat-fill.svg": [
		72443,
		[
			72443
		]
	],
	"./chat-heart-fill.svg": [
		66478,
		[
			66478
		]
	],
	"./chat-heart.svg": [
		62268,
		[
			62268
		]
	],
	"./chat-left-dots-fill.svg": [
		24354,
		[
			24354
		]
	],
	"./chat-left-dots.svg": [
		35784,
		[
			35784
		]
	],
	"./chat-left-fill.svg": [
		51735,
		[
			51735
		]
	],
	"./chat-left-heart-fill.svg": [
		53282,
		[
			53282
		]
	],
	"./chat-left-heart.svg": [
		81736,
		[
			81736
		]
	],
	"./chat-left-quote-fill.svg": [
		8650,
		[
			8650
		]
	],
	"./chat-left-quote.svg": [
		65888,
		[
			65888
		]
	],
	"./chat-left-text-fill.svg": [
		94357,
		[
			94357
		]
	],
	"./chat-left-text.svg": [
		82833,
		[
			82833
		]
	],
	"./chat-left.svg": [
		50843,
		[
			50843
		]
	],
	"./chat-quote-fill.svg": [
		99542,
		[
			99542
		]
	],
	"./chat-quote.svg": [
		47092,
		[
			47092
		]
	],
	"./chat-right-dots-fill.svg": [
		39335,
		[
			39335
		]
	],
	"./chat-right-dots.svg": [
		81611,
		[
			81611
		]
	],
	"./chat-right-fill.svg": [
		54192,
		[
			54192
		]
	],
	"./chat-right-heart-fill.svg": [
		7533,
		[
			7533
		]
	],
	"./chat-right-heart.svg": [
		78937,
		[
			78937
		]
	],
	"./chat-right-quote-fill.svg": [
		1641,
		[
			1641
		]
	],
	"./chat-right-quote.svg": [
		20637,
		[
			20637
		]
	],
	"./chat-right-text-fill.svg": [
		33996,
		[
			33996
		]
	],
	"./chat-right-text.svg": [
		58530,
		[
			58530
		]
	],
	"./chat-right.svg": [
		88062,
		[
			88062
		]
	],
	"./chat-square-dots-fill.svg": [
		42152,
		[
			42152
		]
	],
	"./chat-square-dots.svg": [
		14982,
		[
			14982
		]
	],
	"./chat-square-fill.svg": [
		55097,
		[
			55097
		]
	],
	"./chat-square-heart-fill.svg": [
		94192,
		[
			94192
		]
	],
	"./chat-square-heart.svg": [
		48126,
		[
			48126
		]
	],
	"./chat-square-quote-fill.svg": [
		5912,
		[
			5912
		]
	],
	"./chat-square-quote.svg": [
		78742,
		[
			78742
		]
	],
	"./chat-square-text-fill.svg": [
		95971,
		[
			95971
		]
	],
	"./chat-square-text.svg": [
		52255,
		[
			52255
		]
	],
	"./chat-square.svg": [
		29805,
		[
			29805
		]
	],
	"./chat-text-fill.svg": [
		31585,
		[
			31585
		]
	],
	"./chat-text.svg": [
		72677,
		[
			72677
		]
	],
	"./chat.svg": [
		53159,
		[
			53159
		]
	],
	"./check-all.svg": [
		40937,
		[
			40937
		]
	],
	"./check-circle-fill.svg": [
		16638,
		[
			16638
		]
	],
	"./check-circle.svg": [
		50476,
		[
			50476
		]
	],
	"./check-lg.svg": [
		16587,
		[
			16587
		]
	],
	"./check-square-fill.svg": [
		83921,
		[
			6302
		]
	],
	"./check-square.svg": [
		59669,
		[
			59669
		]
	],
	"./check.svg": [
		3759,
		[
			3759
		]
	],
	"./check2-all.svg": [
		20889,
		[
			20889
		]
	],
	"./check2-circle.svg": [
		10524,
		[
			10524
		]
	],
	"./check2-square.svg": [
		46149,
		[
			46149
		]
	],
	"./check2.svg": [
		59807,
		[
			59807
		]
	],
	"./chevron-bar-contract.svg": [
		93165,
		[
			93165
		]
	],
	"./chevron-bar-down.svg": [
		22155,
		[
			22155
		]
	],
	"./chevron-bar-expand.svg": [
		62847,
		[
			62847
		]
	],
	"./chevron-bar-left.svg": [
		53164,
		[
			53164
		]
	],
	"./chevron-bar-right.svg": [
		24339,
		[
			24339
		]
	],
	"./chevron-bar-up.svg": [
		740,
		[
			740
		]
	],
	"./chevron-compact-down.svg": [
		28223,
		[
			28223
		]
	],
	"./chevron-compact-left.svg": [
		69760,
		[
			69760
		]
	],
	"./chevron-compact-right.svg": [
		91215,
		[
			91215
		]
	],
	"./chevron-compact-up.svg": [
		57200,
		[
			57200
		]
	],
	"./chevron-contract.svg": [
		95685,
		[
			95685
		]
	],
	"./chevron-double-down.svg": [
		43205,
		[
			43205
		]
	],
	"./chevron-double-left.svg": [
		23838,
		[
			23838
		]
	],
	"./chevron-double-right.svg": [
		46429,
		[
			46429
		]
	],
	"./chevron-double-up.svg": [
		94122,
		[
			94122
		]
	],
	"./chevron-down.svg": [
		3491,
		[
			3491
		]
	],
	"./chevron-expand.svg": [
		69015,
		[
			69015
		]
	],
	"./chevron-left.svg": [
		27540,
		[
			27540
		]
	],
	"./chevron-right.svg": [
		2555,
		[
			2555
		]
	],
	"./chevron-up.svg": [
		52988,
		[
			52988
		]
	],
	"./circle-fill.svg": [
		6285,
		[
			6285
		]
	],
	"./circle-half.svg": [
		42941,
		[
			42941
		]
	],
	"./circle-square.svg": [
		21835,
		[
			21835
		]
	],
	"./circle.svg": [
		10681,
		[
			10681
		]
	],
	"./claude.svg": [
		40571,
		[
			40571
		]
	],
	"./clipboard-check-fill.svg": [
		16624,
		[
			16624
		]
	],
	"./clipboard-check.svg": [
		1086,
		[
			1086
		]
	],
	"./clipboard-data-fill.svg": [
		99904,
		[
			99904
		]
	],
	"./clipboard-data.svg": [
		84174,
		[
			84174
		]
	],
	"./clipboard-fill.svg": [
		56237,
		[
			56237
		]
	],
	"./clipboard-heart-fill.svg": [
		39404,
		[
			39404
		]
	],
	"./clipboard-heart.svg": [
		49250,
		[
			49250
		]
	],
	"./clipboard-minus-fill.svg": [
		5492,
		[
			5492
		]
	],
	"./clipboard-minus.svg": [
		36218,
		[
			36218
		]
	],
	"./clipboard-plus-fill.svg": [
		10684,
		[
			10684
		]
	],
	"./clipboard-plus.svg": [
		49746,
		[
			49746
		]
	],
	"./clipboard-pulse.svg": [
		41825,
		[
			41825
		]
	],
	"./clipboard-x-fill.svg": [
		68,
		[
			68
		]
	],
	"./clipboard-x.svg": [
		55338,
		[
			55338
		]
	],
	"./clipboard.svg": [
		73337,
		[
			73337
		]
	],
	"./clipboard2-check-fill.svg": [
		32704,
		[
			32704
		]
	],
	"./clipboard2-check.svg": [
		86446,
		[
			86446
		]
	],
	"./clipboard2-data-fill.svg": [
		11280,
		[
			11280
		]
	],
	"./clipboard2-data.svg": [
		47550,
		[
			47550
		]
	],
	"./clipboard2-fill.svg": [
		60157,
		[
			60157
		]
	],
	"./clipboard2-heart-fill.svg": [
		41660,
		[
			41660
		]
	],
	"./clipboard2-heart.svg": [
		29906,
		[
			29906
		]
	],
	"./clipboard2-minus-fill.svg": [
		19972,
		[
			19972
		]
	],
	"./clipboard2-minus.svg": [
		28266,
		[
			28266
		]
	],
	"./clipboard2-plus-fill.svg": [
		42220,
		[
			42220
		]
	],
	"./clipboard2-plus.svg": [
		8386,
		[
			8386
		]
	],
	"./clipboard2-pulse-fill.svg": [
		95221,
		[
			95221
		]
	],
	"./clipboard2-pulse.svg": [
		41329,
		[
			41329
		]
	],
	"./clipboard2-x-fill.svg": [
		73204,
		[
			73204
		]
	],
	"./clipboard2-x.svg": [
		29549,
		[
			51930
		]
	],
	"./clipboard2.svg": [
		31081,
		[
			31081
		]
	],
	"./clock-fill.svg": [
		25217,
		[
			25217
		]
	],
	"./clock-history.svg": [
		2914,
		[
			2914
		]
	],
	"./clock.svg": [
		70405,
		[
			70405
		]
	],
	"./cloud-arrow-down-fill.svg": [
		89209,
		[
			89209
		]
	],
	"./cloud-arrow-down.svg": [
		75021,
		[
			75021
		]
	],
	"./cloud-arrow-up-fill.svg": [
		15100,
		[
			15100
		]
	],
	"./cloud-arrow-up.svg": [
		71634,
		[
			71634
		]
	],
	"./cloud-check-fill.svg": [
		40423,
		[
			40423
		]
	],
	"./cloud-check.svg": [
		35435,
		[
			35435
		]
	],
	"./cloud-download-fill.svg": [
		31869,
		[
			31869
		]
	],
	"./cloud-download.svg": [
		73417,
		[
			73417
		]
	],
	"./cloud-drizzle-fill.svg": [
		66985,
		[
			66985
		]
	],
	"./cloud-drizzle.svg": [
		11837,
		[
			11837
		]
	],
	"./cloud-fill.svg": [
		450,
		[
			450
		]
	],
	"./cloud-fog-fill.svg": [
		20087,
		[
			20087
		]
	],
	"./cloud-fog.svg": [
		24859,
		[
			24859
		]
	],
	"./cloud-fog2-fill.svg": [
		77039,
		[
			77039
		]
	],
	"./cloud-fog2.svg": [
		803,
		[
			803
		]
	],
	"./cloud-hail-fill.svg": [
		48031,
		[
			48031
		]
	],
	"./cloud-hail.svg": [
		22131,
		[
			22131
		]
	],
	"./cloud-haze-fill.svg": [
		47827,
		[
			47827
		]
	],
	"./cloud-haze.svg": [
		68015,
		[
			68015
		]
	],
	"./cloud-haze2-fill.svg": [
		9219,
		[
			9219
		]
	],
	"./cloud-haze2.svg": [
		17055,
		[
			17055
		]
	],
	"./cloud-lightning-fill.svg": [
		57693,
		[
			57693
		]
	],
	"./cloud-lightning-rain-fill.svg": [
		59594,
		[
			59594
		]
	],
	"./cloud-lightning-rain.svg": [
		93856,
		[
			93856
		]
	],
	"./cloud-lightning.svg": [
		96585,
		[
			96585
		]
	],
	"./cloud-minus-fill.svg": [
		83955,
		[
			83955
		]
	],
	"./cloud-minus.svg": [
		71727,
		[
			71727
		]
	],
	"./cloud-moon-fill.svg": [
		74236,
		[
			74236
		]
	],
	"./cloud-moon.svg": [
		13074,
		[
			13074
		]
	],
	"./cloud-plus-fill.svg": [
		89221,
		[
			89221
		]
	],
	"./cloud-plus.svg": [
		75393,
		[
			75393
		]
	],
	"./cloud-rain-fill.svg": [
		93723,
		[
			93723
		]
	],
	"./cloud-rain-heavy-fill.svg": [
		19081,
		[
			19081
		]
	],
	"./cloud-rain-heavy.svg": [
		35965,
		[
			35965
		]
	],
	"./cloud-rain.svg": [
		92359,
		[
			92359
		]
	],
	"./cloud-slash-fill.svg": [
		17594,
		[
			17594
		]
	],
	"./cloud-slash.svg": [
		56624,
		[
			56624
		]
	],
	"./cloud-sleet-fill.svg": [
		55708,
		[
			55708
		]
	],
	"./cloud-sleet.svg": [
		66354,
		[
			66354
		]
	],
	"./cloud-snow-fill.svg": [
		21998,
		[
			21998
		]
	],
	"./cloud-snow.svg": [
		83804,
		[
			83804
		]
	],
	"./cloud-sun-fill.svg": [
		14337,
		[
			14337
		]
	],
	"./cloud-sun.svg": [
		97605,
		[
			97605
		]
	],
	"./cloud-upload-fill.svg": [
		63920,
		[
			63920
		]
	],
	"./cloud-upload.svg": [
		49118,
		[
			49118
		]
	],
	"./cloud.svg": [
		49800,
		[
			49800
		]
	],
	"./clouds-fill.svg": [
		84663,
		[
			84663
		]
	],
	"./clouds.svg": [
		10395,
		[
			10395
		]
	],
	"./cloudy-fill.svg": [
		61957,
		[
			61957
		]
	],
	"./cloudy.svg": [
		84513,
		[
			84513
		]
	],
	"./code-slash.svg": [
		39110,
		[
			39110
		]
	],
	"./code-square.svg": [
		36578,
		[
			36578
		]
	],
	"./code.svg": [
		50150,
		[
			50150
		]
	],
	"./coin.svg": [
		5890,
		[
			5890
		]
	],
	"./collection-fill.svg": [
		68989,
		[
			68989
		]
	],
	"./collection-play-fill.svg": [
		79630,
		[
			79630
		]
	],
	"./collection-play.svg": [
		89276,
		[
			89276
		]
	],
	"./collection.svg": [
		83561,
		[
			83561
		]
	],
	"./columns-gap.svg": [
		97329,
		[
			97329
		]
	],
	"./columns.svg": [
		17882,
		[
			17882
		]
	],
	"./command.svg": [
		65312,
		[
			65312
		]
	],
	"./compass-fill.svg": [
		27295,
		[
			27295
		]
	],
	"./compass.svg": [
		51603,
		[
			51603
		]
	],
	"./cone-striped.svg": [
		68718,
		[
			68718
		]
	],
	"./cone.svg": [
		77012,
		[
			77012
		]
	],
	"./controller.svg": [
		28941,
		[
			28941
		]
	],
	"./cookie.svg": [
		64999,
		[
			64999
		]
	],
	"./copy.svg": [
		75158,
		[
			75158
		]
	],
	"./cpu-fill.svg": [
		61289,
		[
			61289
		]
	],
	"./cpu.svg": [
		87933,
		[
			87933
		]
	],
	"./credit-card-2-back-fill.svg": [
		94430,
		[
			94430
		]
	],
	"./credit-card-2-back.svg": [
		34092,
		[
			34092
		]
	],
	"./credit-card-2-front-fill.svg": [
		97344,
		[
			97344
		]
	],
	"./credit-card-2-front.svg": [
		59918,
		[
			59918
		]
	],
	"./credit-card-fill.svg": [
		93225,
		[
			93225
		]
	],
	"./credit-card.svg": [
		74077,
		[
			74077
		]
	],
	"./crop.svg": [
		31227,
		[
			31227
		]
	],
	"./crosshair.svg": [
		33247,
		[
			33247
		]
	],
	"./crosshair2.svg": [
		10095,
		[
			10095
		]
	],
	"./css.svg": [
		37594,
		[
			37594
		]
	],
	"./cup-fill.svg": [
		69227,
		[
			69227
		]
	],
	"./cup-hot-fill.svg": [
		34629,
		[
			34629
		]
	],
	"./cup-hot.svg": [
		49953,
		[
			49953
		]
	],
	"./cup-straw.svg": [
		81029,
		[
			81029
		]
	],
	"./cup.svg": [
		91063,
		[
			91063
		]
	],
	"./currency-bitcoin.svg": [
		94489,
		[
			94489
		]
	],
	"./currency-dollar.svg": [
		43211,
		[
			43211
		]
	],
	"./currency-euro.svg": [
		78710,
		[
			78710
		]
	],
	"./currency-exchange.svg": [
		63610,
		[
			63610
		]
	],
	"./currency-pound.svg": [
		56553,
		[
			56553
		]
	],
	"./currency-rupee.svg": [
		53032,
		[
			53032
		]
	],
	"./currency-yen.svg": [
		61251,
		[
			61251
		]
	],
	"./cursor-fill.svg": [
		64839,
		[
			64839
		]
	],
	"./cursor-text.svg": [
		51809,
		[
			51809
		]
	],
	"./cursor.svg": [
		45867,
		[
			45867
		]
	],
	"./dash-circle-dotted.svg": [
		45099,
		[
			45099
		]
	],
	"./dash-circle-fill.svg": [
		69828,
		[
			69828
		]
	],
	"./dash-circle.svg": [
		78890,
		[
			78890
		]
	],
	"./dash-lg.svg": [
		53849,
		[
			53849
		]
	],
	"./dash-square-dotted.svg": [
		60776,
		[
			60776
		]
	],
	"./dash-square-fill.svg": [
		24563,
		[
			24563
		]
	],
	"./dash-square.svg": [
		76879,
		[
			76879
		]
	],
	"./dash.svg": [
		83869,
		[
			83869
		]
	],
	"./database-add.svg": [
		34920,
		[
			34920
		]
	],
	"./database-check.svg": [
		65521,
		[
			65521
		]
	],
	"./database-dash.svg": [
		28336,
		[
			28336
		]
	],
	"./database-down.svg": [
		98171,
		[
			98171
		]
	],
	"./database-exclamation.svg": [
		58006,
		[
			58006
		]
	],
	"./database-fill-add.svg": [
		64082,
		[
			64082
		]
	],
	"./database-fill-check.svg": [
		25103,
		[
			25103
		]
	],
	"./database-fill-dash.svg": [
		47197,
		[
			47197
		]
	],
	"./database-fill-down.svg": [
		36829,
		[
			36829
		]
	],
	"./database-fill-exclamation.svg": [
		62652,
		[
			62652
		]
	],
	"./database-fill-gear.svg": [
		44084,
		[
			44084
		]
	],
	"./database-fill-lock.svg": [
		2236,
		[
			2236
		]
	],
	"./database-fill-slash.svg": [
		99044,
		[
			99044
		]
	],
	"./database-fill-up.svg": [
		21282,
		[
			21282
		]
	],
	"./database-fill-x.svg": [
		18987,
		[
			18987
		]
	],
	"./database-fill.svg": [
		69580,
		[
			69580
		]
	],
	"./database-gear.svg": [
		68150,
		[
			68150
		]
	],
	"./database-lock.svg": [
		6650,
		[
			6650
		]
	],
	"./database-slash.svg": [
		80498,
		[
			80498
		]
	],
	"./database-up.svg": [
		93684,
		[
			93684
		]
	],
	"./database-x.svg": [
		90601,
		[
			90601
		]
	],
	"./database.svg": [
		70658,
		[
			70658
		]
	],
	"./device-hdd-fill.svg": [
		2182,
		[
			2182
		]
	],
	"./device-hdd.svg": [
		38692,
		[
			38692
		]
	],
	"./device-ssd-fill.svg": [
		78728,
		[
			78728
		]
	],
	"./device-ssd.svg": [
		29158,
		[
			29158
		]
	],
	"./diagram-2-fill.svg": [
		14937,
		[
			14937
		]
	],
	"./diagram-2.svg": [
		32621,
		[
			32621
		]
	],
	"./diagram-3-fill.svg": [
		44414,
		[
			44414
		]
	],
	"./diagram-3.svg": [
		80812,
		[
			80812
		]
	],
	"./diamond-fill.svg": [
		87959,
		[
			87959
		]
	],
	"./diamond-half.svg": [
		6327,
		[
			6327
		]
	],
	"./diamond.svg": [
		72795,
		[
			72795
		]
	],
	"./dice-1-fill.svg": [
		63888,
		[
			63888
		]
	],
	"./dice-1.svg": [
		27518,
		[
			27518
		]
	],
	"./dice-2-fill.svg": [
		92681,
		[
			92681
		]
	],
	"./dice-2.svg": [
		73789,
		[
			73789
		]
	],
	"./dice-3-fill.svg": [
		57902,
		[
			57902
		]
	],
	"./dice-3.svg": [
		45244,
		[
			45244
		]
	],
	"./dice-4-fill.svg": [
		7087,
		[
			7087
		]
	],
	"./dice-4.svg": [
		43171,
		[
			43171
		]
	],
	"./dice-5-fill.svg": [
		70556,
		[
			70556
		]
	],
	"./dice-5.svg": [
		39858,
		[
			39858
		]
	],
	"./dice-6-fill.svg": [
		453,
		[
			453
		]
	],
	"./dice-6.svg": [
		44897,
		[
			44897
		]
	],
	"./disc-fill.svg": [
		55808,
		[
			55808
		]
	],
	"./disc.svg": [
		82990,
		[
			82990
		]
	],
	"./discord.svg": [
		86411,
		[
			86411
		]
	],
	"./display-fill.svg": [
		33605,
		[
			33605
		]
	],
	"./display.svg": [
		42113,
		[
			42113
		]
	],
	"./displayport-fill.svg": [
		89198,
		[
			89198
		]
	],
	"./displayport.svg": [
		47100,
		[
			47100
		]
	],
	"./distribute-horizontal.svg": [
		91013,
		[
			91013
		]
	],
	"./distribute-vertical.svg": [
		3571,
		[
			3571
		]
	],
	"./door-closed-fill.svg": [
		3244,
		[
			3244
		]
	],
	"./door-closed.svg": [
		94786,
		[
			94786
		]
	],
	"./door-open-fill.svg": [
		11728,
		[
			11728
		]
	],
	"./door-open.svg": [
		81854,
		[
			81854
		]
	],
	"./dot.svg": [
		94570,
		[
			94570
		]
	],
	"./download.svg": [
		56629,
		[
			56629
		]
	],
	"./dpad-fill.svg": [
		20216,
		[
			20216
		]
	],
	"./dpad.svg": [
		69558,
		[
			69558
		]
	],
	"./dribbble.svg": [
		33611,
		[
			33611
		]
	],
	"./dropbox.svg": [
		83621,
		[
			83621
		]
	],
	"./droplet-fill.svg": [
		65269,
		[
			65269
		]
	],
	"./droplet-half.svg": [
		80917,
		[
			80917
		]
	],
	"./droplet.svg": [
		74193,
		[
			74193
		]
	],
	"./duffle-fill.svg": [
		47593,
		[
			47593
		]
	],
	"./duffle.svg": [
		37309,
		[
			37309
		]
	],
	"./ear-fill.svg": [
		18695,
		[
			18695
		]
	],
	"./ear.svg": [
		29099,
		[
			29099
		]
	],
	"./earbuds.svg": [
		20691,
		[
			20691
		]
	],
	"./easel-fill.svg": [
		35393,
		[
			35393
		]
	],
	"./easel.svg": [
		21765,
		[
			21765
		]
	],
	"./easel2-fill.svg": [
		23513,
		[
			23513
		]
	],
	"./easel2.svg": [
		70253,
		[
			70253
		]
	],
	"./easel3-fill.svg": [
		94,
		[
			94
		]
	],
	"./easel3.svg": [
		22892,
		[
			22892
		]
	],
	"./egg-fill.svg": [
		23170,
		[
			23170
		]
	],
	"./egg-fried.svg": [
		57269,
		[
			57269
		]
	],
	"./egg.svg": [
		90875,
		[
			90875
		]
	],
	"./eject-fill.svg": [
		44994,
		[
			44994
		]
	],
	"./eject.svg": [
		80456,
		[
			80456
		]
	],
	"./emoji-angry-fill.svg": [
		81205,
		[
			81205
		]
	],
	"./emoji-angry.svg": [
		96465,
		[
			96465
		]
	],
	"./emoji-astonished-fill.svg": [
		3510,
		[
			3510
		]
	],
	"./emoji-astonished.svg": [
		3764,
		[
			3764
		]
	],
	"./emoji-dizzy-fill.svg": [
		22854,
		[
			22854
		]
	],
	"./emoji-dizzy.svg": [
		53764,
		[
			53764
		]
	],
	"./emoji-expressionless-fill.svg": [
		66851,
		[
			66851
		]
	],
	"./emoji-expressionless.svg": [
		32255,
		[
			32255
		]
	],
	"./emoji-frown-fill.svg": [
		43372,
		[
			43372
		]
	],
	"./emoji-frown.svg": [
		11458,
		[
			11458
		]
	],
	"./emoji-grimace-fill.svg": [
		65542,
		[
			65542
		]
	],
	"./emoji-grimace.svg": [
		73412,
		[
			73412
		]
	],
	"./emoji-grin-fill.svg": [
		28946,
		[
			28946
		]
	],
	"./emoji-grin.svg": [
		86552,
		[
			86552
		]
	],
	"./emoji-heart-eyes-fill.svg": [
		75197,
		[
			75197
		]
	],
	"./emoji-heart-eyes.svg": [
		82281,
		[
			82281
		]
	],
	"./emoji-kiss-fill.svg": [
		22794,
		[
			22794
		]
	],
	"./emoji-kiss.svg": [
		16352,
		[
			16352
		]
	],
	"./emoji-laughing-fill.svg": [
		38743,
		[
			38743
		]
	],
	"./emoji-laughing.svg": [
		24283,
		[
			24283
		]
	],
	"./emoji-neutral-fill.svg": [
		59519,
		[
			59519
		]
	],
	"./emoji-neutral.svg": [
		7155,
		[
			7155
		]
	],
	"./emoji-smile-fill.svg": [
		73448,
		[
			73448
		]
	],
	"./emoji-smile-upside-down-fill.svg": [
		98216,
		[
			98216
		]
	],
	"./emoji-smile-upside-down.svg": [
		10502,
		[
			10502
		]
	],
	"./emoji-smile.svg": [
		48774,
		[
			48774
		]
	],
	"./emoji-sunglasses-fill.svg": [
		84746,
		[
			84746
		]
	],
	"./emoji-sunglasses.svg": [
		14720,
		[
			14720
		]
	],
	"./emoji-surprise-fill.svg": [
		95967,
		[
			95967
		]
	],
	"./emoji-surprise.svg": [
		371,
		[
			371
		]
	],
	"./emoji-tear-fill.svg": [
		63228,
		[
			63228
		]
	],
	"./emoji-tear.svg": [
		61810,
		[
			61810
		]
	],
	"./emoji-wink-fill.svg": [
		6863,
		[
			6863
		]
	],
	"./emoji-wink.svg": [
		38499,
		[
			38499
		]
	],
	"./envelope-arrow-down-fill.svg": [
		32984,
		[
			32984
		]
	],
	"./envelope-arrow-down.svg": [
		950,
		[
			950
		]
	],
	"./envelope-arrow-up-fill.svg": [
		20697,
		[
			20697
		]
	],
	"./envelope-arrow-up.svg": [
		48621,
		[
			48621
		]
	],
	"./envelope-at-fill.svg": [
		94069,
		[
			94069
		]
	],
	"./envelope-at.svg": [
		35377,
		[
			35377
		]
	],
	"./envelope-check-fill.svg": [
		81212,
		[
			81212
		]
	],
	"./envelope-check.svg": [
		69266,
		[
			69266
		]
	],
	"./envelope-dash-fill.svg": [
		8324,
		[
			8324
		]
	],
	"./envelope-dash.svg": [
		71146,
		[
			71146
		]
	],
	"./envelope-exclamation-fill.svg": [
		99793,
		[
			99793
		]
	],
	"./envelope-exclamation.svg": [
		15093,
		[
			15093
		]
	],
	"./envelope-fill.svg": [
		65721,
		[
			65721
		]
	],
	"./envelope-heart-fill.svg": [
		83696,
		[
			83696
		]
	],
	"./envelope-heart.svg": [
		39614,
		[
			39614
		]
	],
	"./envelope-open-fill.svg": [
		81916,
		[
			81916
		]
	],
	"./envelope-open-heart-fill.svg": [
		89985,
		[
			89985
		]
	],
	"./envelope-open-heart.svg": [
		66373,
		[
			66373
		]
	],
	"./envelope-open.svg": [
		2354,
		[
			2354
		]
	],
	"./envelope-paper-fill.svg": [
		78898,
		[
			78898
		]
	],
	"./envelope-paper-heart-fill.svg": [
		42659,
		[
			42659
		]
	],
	"./envelope-paper-heart.svg": [
		33855,
		[
			33855
		]
	],
	"./envelope-paper.svg": [
		66424,
		[
			66424
		]
	],
	"./envelope-plus-fill.svg": [
		8776,
		[
			8776
		]
	],
	"./envelope-plus.svg": [
		61894,
		[
			61894
		]
	],
	"./envelope-slash-fill.svg": [
		80762,
		[
			58381
		]
	],
	"./envelope-slash.svg": [
		16217,
		[
			16217
		]
	],
	"./envelope-x-fill.svg": [
		81096,
		[
			81096
		]
	],
	"./envelope-x.svg": [
		71494,
		[
			71494
		]
	],
	"./envelope.svg": [
		12557,
		[
			12557
		]
	],
	"./eraser-fill.svg": [
		94129,
		[
			94129
		]
	],
	"./eraser.svg": [
		87189,
		[
			87189
		]
	],
	"./escape.svg": [
		18132,
		[
			18132
		]
	],
	"./ethernet.svg": [
		10236,
		[
			10236
		]
	],
	"./ev-front-fill.svg": [
		48864,
		[
			48864
		]
	],
	"./ev-front.svg": [
		18126,
		[
			18126
		]
	],
	"./ev-station-fill.svg": [
		16895,
		[
			16895
		]
	],
	"./ev-station.svg": [
		89107,
		[
			89107
		]
	],
	"./exclamation-circle-fill.svg": [
		92221,
		[
			92221
		]
	],
	"./exclamation-circle.svg": [
		4585,
		[
			4585
		]
	],
	"./exclamation-diamond-fill.svg": [
		583,
		[
			583
		]
	],
	"./exclamation-diamond.svg": [
		69323,
		[
			69323
		]
	],
	"./exclamation-lg.svg": [
		45290,
		[
			45290
		]
	],
	"./exclamation-octagon-fill.svg": [
		24420,
		[
			24420
		]
	],
	"./exclamation-octagon.svg": [
		67882,
		[
			45501
		]
	],
	"./exclamation-square-fill.svg": [
		36606,
		[
			36606
		]
	],
	"./exclamation-square.svg": [
		16012,
		[
			16012
		]
	],
	"./exclamation-triangle-fill.svg": [
		45945,
		[
			45945
		]
	],
	"./exclamation-triangle.svg": [
		48653,
		[
			48653
		]
	],
	"./exclamation.svg": [
		20284,
		[
			20284
		]
	],
	"./exclude.svg": [
		19973,
		[
			19973
		]
	],
	"./explicit-fill.svg": [
		31885,
		[
			31885
		]
	],
	"./explicit.svg": [
		1753,
		[
			1753
		]
	],
	"./exposure.svg": [
		14238,
		[
			14238
		]
	],
	"./eye-fill.svg": [
		49246,
		[
			49246
		]
	],
	"./eye-slash-fill.svg": [
		7110,
		[
			7110
		]
	],
	"./eye-slash.svg": [
		60836,
		[
			60836
		]
	],
	"./eye.svg": [
		38188,
		[
			38188
		]
	],
	"./eyedropper.svg": [
		98136,
		[
			98136
		]
	],
	"./eyeglasses.svg": [
		90628,
		[
			90628
		]
	],
	"./facebook.svg": [
		2733,
		[
			2733
		]
	],
	"./fan.svg": [
		41836,
		[
			41836
		]
	],
	"./fast-forward-btn-fill.svg": [
		53202,
		[
			53202
		]
	],
	"./fast-forward-btn.svg": [
		56216,
		[
			56216
		]
	],
	"./fast-forward-circle-fill.svg": [
		19478,
		[
			19478
		]
	],
	"./fast-forward-circle.svg": [
		82644,
		[
			82644
		]
	],
	"./fast-forward-fill.svg": [
		61483,
		[
			61483
		]
	],
	"./fast-forward.svg": [
		23383,
		[
			23383
		]
	],
	"./feather.svg": [
		37214,
		[
			37214
		]
	],
	"./feather2.svg": [
		95056,
		[
			95056
		]
	],
	"./file-arrow-down-fill.svg": [
		74786,
		[
			74786
		]
	],
	"./file-arrow-down.svg": [
		14760,
		[
			14760
		]
	],
	"./file-arrow-up-fill.svg": [
		57911,
		[
			57911
		]
	],
	"./file-arrow-up.svg": [
		27547,
		[
			27547
		]
	],
	"./file-bar-graph-fill.svg": [
		28702,
		[
			28702
		]
	],
	"./file-bar-graph.svg": [
		33292,
		[
			33292
		]
	],
	"./file-binary-fill.svg": [
		45328,
		[
			45328
		]
	],
	"./file-binary.svg": [
		41183,
		[
			41183
		]
	],
	"./file-break-fill.svg": [
		61881,
		[
			61881
		]
	],
	"./file-break.svg": [
		76173,
		[
			76173
		]
	],
	"./file-check-fill.svg": [
		21330,
		[
			21330
		]
	],
	"./file-check.svg": [
		83800,
		[
			83800
		]
	],
	"./file-code-fill.svg": [
		95411,
		[
			95411
		]
	],
	"./file-code.svg": [
		22415,
		[
			22415
		]
	],
	"./file-diff-fill.svg": [
		11985,
		[
			11985
		]
	],
	"./file-diff.svg": [
		28917,
		[
			28917
		]
	],
	"./file-earmark-arrow-down-fill.svg": [
		63022,
		[
			63022
		]
	],
	"./file-earmark-arrow-down.svg": [
		3292,
		[
			3292
		]
	],
	"./file-earmark-arrow-up-fill.svg": [
		73451,
		[
			73451
		]
	],
	"./file-earmark-arrow-up.svg": [
		28119,
		[
			28119
		]
	],
	"./file-earmark-bar-graph-fill.svg": [
		29450,
		[
			29450
		]
	],
	"./file-earmark-bar-graph.svg": [
		99552,
		[
			99552
		]
	],
	"./file-earmark-binary-fill.svg": [
		43199,
		[
			43199
		]
	],
	"./file-earmark-binary.svg": [
		12819,
		[
			12819
		]
	],
	"./file-earmark-break-fill.svg": [
		54669,
		[
			54669
		]
	],
	"./file-earmark-break.svg": [
		5241,
		[
			5241
		]
	],
	"./file-earmark-check-fill.svg": [
		58454,
		[
			58454
		]
	],
	"./file-earmark-check.svg": [
		15156,
		[
			15156
		]
	],
	"./file-earmark-code-fill.svg": [
		8607,
		[
			8607
		]
	],
	"./file-earmark-code.svg": [
		45427,
		[
			45427
		]
	],
	"./file-earmark-diff-fill.svg": [
		97245,
		[
			97245
		]
	],
	"./file-earmark-diff.svg": [
		80553,
		[
			80553
		]
	],
	"./file-earmark-easel-fill.svg": [
		66676,
		[
			66676
		]
	],
	"./file-earmark-easel.svg": [
		46394,
		[
			46394
		]
	],
	"./file-earmark-excel-fill.svg": [
		18289,
		[
			18289
		]
	],
	"./file-earmark-excel.svg": [
		20277,
		[
			20277
		]
	],
	"./file-earmark-fill.svg": [
		21599,
		[
			21599
		]
	],
	"./file-earmark-font-fill.svg": [
		23375,
		[
			23375
		]
	],
	"./file-earmark-font.svg": [
		44963,
		[
			44963
		]
	],
	"./file-earmark-image-fill.svg": [
		31391,
		[
			31391
		]
	],
	"./file-earmark-image.svg": [
		15795,
		[
			15795
		]
	],
	"./file-earmark-lock-fill.svg": [
		25429,
		[
			25429
		]
	],
	"./file-earmark-lock.svg": [
		67281,
		[
			67281
		]
	],
	"./file-earmark-lock2-fill.svg": [
		98805,
		[
			98805
		]
	],
	"./file-earmark-lock2.svg": [
		5841,
		[
			5841
		]
	],
	"./file-earmark-medical-fill.svg": [
		80141,
		[
			80141
		]
	],
	"./file-earmark-medical.svg": [
		49753,
		[
			49753
		]
	],
	"./file-earmark-minus-fill.svg": [
		42182,
		[
			42182
		]
	],
	"./file-earmark-minus.svg": [
		68676,
		[
			68676
		]
	],
	"./file-earmark-music-fill.svg": [
		91089,
		[
			91089
		]
	],
	"./file-earmark-music.svg": [
		373,
		[
			373
		]
	],
	"./file-earmark-pdf-fill.svg": [
		10464,
		[
			10464
		]
	],
	"./file-earmark-pdf.svg": [
		63726,
		[
			63726
		]
	],
	"./file-earmark-person-fill.svg": [
		9135,
		[
			9135
		]
	],
	"./file-earmark-person.svg": [
		98467,
		[
			98467
		]
	],
	"./file-earmark-play-fill.svg": [
		76364,
		[
			76364
		]
	],
	"./file-earmark-play.svg": [
		7522,
		[
			7522
		]
	],
	"./file-earmark-plus-fill.svg": [
		20318,
		[
			20318
		]
	],
	"./file-earmark-plus.svg": [
		66476,
		[
			66476
		]
	],
	"./file-earmark-post-fill.svg": [
		40348,
		[
			40348
		]
	],
	"./file-earmark-post.svg": [
		93266,
		[
			93266
		]
	],
	"./file-earmark-ppt-fill.svg": [
		88626,
		[
			88626
		]
	],
	"./file-earmark-ppt.svg": [
		42072,
		[
			42072
		]
	],
	"./file-earmark-richtext-fill.svg": [
		31775,
		[
			31775
		]
	],
	"./file-earmark-richtext.svg": [
		49587,
		[
			49587
		]
	],
	"./file-earmark-ruled-fill.svg": [
		66848,
		[
			66848
		]
	],
	"./file-earmark-ruled.svg": [
		44206,
		[
			44206
		]
	],
	"./file-earmark-slides-fill.svg": [
		58284,
		[
			58284
		]
	],
	"./file-earmark-slides.svg": [
		37634,
		[
			37634
		]
	],
	"./file-earmark-spreadsheet-fill.svg": [
		46644,
		[
			46644
		]
	],
	"./file-earmark-spreadsheet.svg": [
		97562,
		[
			97562
		]
	],
	"./file-earmark-text-fill.svg": [
		89133,
		[
			89133
		]
	],
	"./file-earmark-text.svg": [
		89017,
		[
			89017
		]
	],
	"./file-earmark-word-fill.svg": [
		28182,
		[
			28182
		]
	],
	"./file-earmark-word.svg": [
		86292,
		[
			86292
		]
	],
	"./file-earmark-x-fill.svg": [
		29086,
		[
			29086
		]
	],
	"./file-earmark-x.svg": [
		8556,
		[
			8556
		]
	],
	"./file-earmark-zip-fill.svg": [
		91717,
		[
			91717
		]
	],
	"./file-earmark-zip.svg": [
		17089,
		[
			17089
		]
	],
	"./file-earmark.svg": [
		37235,
		[
			37235
		]
	],
	"./file-easel-fill.svg": [
		72064,
		[
			72064
		]
	],
	"./file-easel.svg": [
		9902,
		[
			9902
		]
	],
	"./file-excel-fill.svg": [
		53805,
		[
			53805
		]
	],
	"./file-excel.svg": [
		81625,
		[
			81625
		]
	],
	"./file-fill.svg": [
		15739,
		[
			15739
		]
	],
	"./file-font-fill.svg": [
		16187,
		[
			16187
		]
	],
	"./file-font.svg": [
		2119,
		[
			2119
		]
	],
	"./file-image-fill.svg": [
		64971,
		[
			64971
		]
	],
	"./file-image.svg": [
		3671,
		[
			3671
		]
	],
	"./file-lock-fill.svg": [
		64785,
		[
			64785
		]
	],
	"./file-lock.svg": [
		55221,
		[
			55221
		]
	],
	"./file-lock2-fill.svg": [
		40777,
		[
			40777
		]
	],
	"./file-lock2.svg": [
		477,
		[
			477
		]
	],
	"./file-medical-fill.svg": [
		95153,
		[
			95153
		]
	],
	"./file-medical.svg": [
		89301,
		[
			89301
		]
	],
	"./file-minus-fill.svg": [
		11714,
		[
			11714
		]
	],
	"./file-minus.svg": [
		38344,
		[
			38344
		]
	],
	"./file-music-fill.svg": [
		30757,
		[
			30757
		]
	],
	"./file-music.svg": [
		44033,
		[
			44033
		]
	],
	"./file-pdf-fill.svg": [
		62948,
		[
			62948
		]
	],
	"./file-pdf.svg": [
		42474,
		[
			42474
		]
	],
	"./file-person-fill.svg": [
		96931,
		[
			96931
		]
	],
	"./file-person.svg": [
		81951,
		[
			81951
		]
	],
	"./file-play-fill.svg": [
		63280,
		[
			63280
		]
	],
	"./file-play.svg": [
		30558,
		[
			30558
		]
	],
	"./file-plus-fill.svg": [
		34122,
		[
			34122
		]
	],
	"./file-plus.svg": [
		25984,
		[
			25984
		]
	],
	"./file-post-fill.svg": [
		2600,
		[
			2600
		]
	],
	"./file-post.svg": [
		61318,
		[
			61318
		]
	],
	"./file-ppt-fill.svg": [
		83169,
		[
			83169
		]
	],
	"./file-ppt.svg": [
		56700,
		[
			56700
		]
	],
	"./file-richtext-fill.svg": [
		80403,
		[
			80403
		]
	],
	"./file-richtext.svg": [
		3343,
		[
			3343
		]
	],
	"./file-ruled-fill.svg": [
		20932,
		[
			20932
		]
	],
	"./file-ruled.svg": [
		17322,
		[
			17322
		]
	],
	"./file-slides-fill.svg": [
		54368,
		[
			54368
		]
	],
	"./file-slides.svg": [
		62702,
		[
			62702
		]
	],
	"./file-spreadsheet-fill.svg": [
		37568,
		[
			15187
		]
	],
	"./file-spreadsheet.svg": [
		86542,
		[
			86542
		]
	],
	"./file-text-fill.svg": [
		54241,
		[
			54241
		]
	],
	"./file-text.svg": [
		15973,
		[
			15973
		]
	],
	"./file-word-fill.svg": [
		57626,
		[
			57626
		]
	],
	"./file-word.svg": [
		38416,
		[
			38416
		]
	],
	"./file-x-fill.svg": [
		84098,
		[
			84098
		]
	],
	"./file-x.svg": [
		41096,
		[
			41096
		]
	],
	"./file-zip-fill.svg": [
		27817,
		[
			27817
		]
	],
	"./file-zip.svg": [
		41181,
		[
			41181
		]
	],
	"./file.svg": [
		66407,
		[
			66407
		]
	],
	"./files-alt.svg": [
		11436,
		[
			11436
		]
	],
	"./files.svg": [
		53942,
		[
			53942
		]
	],
	"./filetype-aac.svg": [
		43621,
		[
			43621
		]
	],
	"./filetype-ai.svg": [
		70770,
		[
			70770
		]
	],
	"./filetype-bmp.svg": [
		14985,
		[
			14985
		]
	],
	"./filetype-cs.svg": [
		88562,
		[
			88562
		]
	],
	"./filetype-css.svg": [
		99469,
		[
			99469
		]
	],
	"./filetype-csv.svg": [
		13664,
		[
			13664
		]
	],
	"./filetype-doc.svg": [
		99266,
		[
			99266
		]
	],
	"./filetype-docx.svg": [
		86710,
		[
			86710
		]
	],
	"./filetype-exe.svg": [
		3960,
		[
			3960
		]
	],
	"./filetype-gif.svg": [
		52698,
		[
			52698
		]
	],
	"./filetype-heic.svg": [
		90337,
		[
			90337
		]
	],
	"./filetype-html.svg": [
		1703,
		[
			1703
		]
	],
	"./filetype-java.svg": [
		13928,
		[
			13928
		]
	],
	"./filetype-jpg.svg": [
		87197,
		[
			87197
		]
	],
	"./filetype-js.svg": [
		88749,
		[
			88749
		]
	],
	"./filetype-json.svg": [
		8886,
		[
			8886
		]
	],
	"./filetype-jsx.svg": [
		42687,
		[
			42687
		]
	],
	"./filetype-key.svg": [
		53813,
		[
			53813
		]
	],
	"./filetype-m4p.svg": [
		59457,
		[
			59457
		]
	],
	"./filetype-md.svg": [
		58763,
		[
			58763
		]
	],
	"./filetype-mdx.svg": [
		67145,
		[
			67145
		]
	],
	"./filetype-mov.svg": [
		28734,
		[
			28734
		]
	],
	"./filetype-mp3.svg": [
		35318,
		[
			35318
		]
	],
	"./filetype-mp4.svg": [
		2649,
		[
			2649
		]
	],
	"./filetype-otf.svg": [
		7741,
		[
			7741
		]
	],
	"./filetype-pdf.svg": [
		57682,
		[
			57682
		]
	],
	"./filetype-php.svg": [
		15187,
		[
			37568
		]
	],
	"./filetype-png.svg": [
		46893,
		[
			46893
		]
	],
	"./filetype-ppt.svg": [
		76471,
		[
			98852
		]
	],
	"./filetype-pptx.svg": [
		62772,
		[
			62772
		]
	],
	"./filetype-psd.svg": [
		84093,
		[
			84093
		]
	],
	"./filetype-py.svg": [
		64241,
		[
			64241
		]
	],
	"./filetype-raw.svg": [
		89642,
		[
			89642
		]
	],
	"./filetype-rb.svg": [
		94868,
		[
			94868
		]
	],
	"./filetype-sass.svg": [
		75514,
		[
			75514
		]
	],
	"./filetype-scss.svg": [
		80068,
		[
			80068
		]
	],
	"./filetype-sh.svg": [
		47577,
		[
			47577
		]
	],
	"./filetype-sql.svg": [
		93444,
		[
			93444
		]
	],
	"./filetype-svg.svg": [
		43330,
		[
			43330
		]
	],
	"./filetype-tiff.svg": [
		66637,
		[
			66637
		]
	],
	"./filetype-tsx.svg": [
		99935,
		[
			77554
		]
	],
	"./filetype-ttf.svg": [
		44062,
		[
			44062
		]
	],
	"./filetype-txt.svg": [
		12320,
		[
			12320
		]
	],
	"./filetype-wav.svg": [
		19938,
		[
			19938
		]
	],
	"./filetype-woff.svg": [
		41374,
		[
			41374
		]
	],
	"./filetype-xls.svg": [
		6927,
		[
			6927
		]
	],
	"./filetype-xlsx.svg": [
		27781,
		[
			27781
		]
	],
	"./filetype-xml.svg": [
		38651,
		[
			38651
		]
	],
	"./filetype-yml.svg": [
		18142,
		[
			18142
		]
	],
	"./film.svg": [
		86959,
		[
			86959
		]
	],
	"./filter-circle-fill.svg": [
		92662,
		[
			92662
		]
	],
	"./filter-circle.svg": [
		53556,
		[
			53556
		]
	],
	"./filter-left.svg": [
		63691,
		[
			63691
		]
	],
	"./filter-right.svg": [
		34734,
		[
			34734
		]
	],
	"./filter-square-fill.svg": [
		78217,
		[
			78217
		]
	],
	"./filter-square.svg": [
		70845,
		[
			70845
		]
	],
	"./filter.svg": [
		46391,
		[
			46391
		]
	],
	"./fingerprint.svg": [
		41999,
		[
			41999
		]
	],
	"./fire.svg": [
		36429,
		[
			36429
		]
	],
	"./flag-fill.svg": [
		23115,
		[
			23115
		]
	],
	"./flag.svg": [
		37431,
		[
			37431
		]
	],
	"./flask-fill.svg": [
		94452,
		[
			94452
		]
	],
	"./flask-florence-fill.svg": [
		4431,
		[
			4431
		]
	],
	"./flask-florence.svg": [
		20707,
		[
			20707
		]
	],
	"./flask.svg": [
		90234,
		[
			90234
		]
	],
	"./floppy-fill.svg": [
		68007,
		[
			68007
		]
	],
	"./floppy.svg": [
		76811,
		[
			76811
		]
	],
	"./floppy2-fill.svg": [
		69471,
		[
			69471
		]
	],
	"./floppy2.svg": [
		85715,
		[
			85715
		]
	],
	"./flower1.svg": [
		78749,
		[
			78749
		]
	],
	"./flower2.svg": [
		24574,
		[
			24574
		]
	],
	"./flower3.svg": [
		68303,
		[
			68303
		]
	],
	"./folder-check.svg": [
		14682,
		[
			14682
		]
	],
	"./folder-fill.svg": [
		75073,
		[
			75073
		]
	],
	"./folder-minus.svg": [
		48710,
		[
			48710
		]
	],
	"./folder-plus.svg": [
		68430,
		[
			68430
		]
	],
	"./folder-symlink-fill.svg": [
		72287,
		[
			72287
		]
	],
	"./folder-symlink.svg": [
		87859,
		[
			87859
		]
	],
	"./folder-x.svg": [
		25758,
		[
			25758
		]
	],
	"./folder.svg": [
		68421,
		[
			68421
		]
	],
	"./folder2-open.svg": [
		61010,
		[
			61010
		]
	],
	"./folder2.svg": [
		55149,
		[
			55149
		]
	],
	"./fonts.svg": [
		89321,
		[
			89321
		]
	],
	"./fork-knife.svg": [
		11541,
		[
			11541
		]
	],
	"./forward-fill.svg": [
		30898,
		[
			30898
		]
	],
	"./forward.svg": [
		72184,
		[
			72184
		]
	],
	"./front.svg": [
		36286,
		[
			36286
		]
	],
	"./fuel-pump-diesel-fill.svg": [
		81515,
		[
			81515
		]
	],
	"./fuel-pump-diesel.svg": [
		22039,
		[
			22039
		]
	],
	"./fuel-pump-fill.svg": [
		80890,
		[
			80890
		]
	],
	"./fuel-pump.svg": [
		37392,
		[
			37392
		]
	],
	"./fullscreen-exit.svg": [
		1735,
		[
			1735
		]
	],
	"./fullscreen.svg": [
		22766,
		[
			22766
		]
	],
	"./funnel-fill.svg": [
		25957,
		[
			25957
		]
	],
	"./funnel.svg": [
		80385,
		[
			80385
		]
	],
	"./gear-fill.svg": [
		42614,
		[
			42614
		]
	],
	"./gear-wide-connected.svg": [
		31034,
		[
			31034
		]
	],
	"./gear-wide.svg": [
		69156,
		[
			69156
		]
	],
	"./gear.svg": [
		40788,
		[
			40788
		]
	],
	"./gem.svg": [
		96158,
		[
			96158
		]
	],
	"./gender-ambiguous.svg": [
		29317,
		[
			29317
		]
	],
	"./gender-female.svg": [
		35187,
		[
			35187
		]
	],
	"./gender-male.svg": [
		88432,
		[
			88432
		]
	],
	"./gender-neuter.svg": [
		48826,
		[
			48826
		]
	],
	"./gender-trans.svg": [
		42795,
		[
			42795
		]
	],
	"./geo-alt-fill.svg": [
		9780,
		[
			9780
		]
	],
	"./geo-alt.svg": [
		65850,
		[
			65850
		]
	],
	"./geo-fill.svg": [
		97358,
		[
			97358
		]
	],
	"./geo.svg": [
		96060,
		[
			96060
		]
	],
	"./gift-fill.svg": [
		29563,
		[
			29563
		]
	],
	"./gift.svg": [
		29895,
		[
			29895
		]
	],
	"./git.svg": [
		7515,
		[
			7515
		]
	],
	"./github.svg": [
		49416,
		[
			49416
		]
	],
	"./gitlab.svg": [
		75776,
		[
			75776
		]
	],
	"./globe-americas-fill.svg": [
		48444,
		[
			48444
		]
	],
	"./globe-americas.svg": [
		1394,
		[
			1394
		]
	],
	"./globe-asia-australia-fill.svg": [
		81724,
		[
			81724
		]
	],
	"./globe-asia-australia.svg": [
		4402,
		[
			4402
		]
	],
	"./globe-central-south-asia-fill.svg": [
		59183,
		[
			59183
		]
	],
	"./globe-central-south-asia.svg": [
		36451,
		[
			36451
		]
	],
	"./globe-europe-africa-fill.svg": [
		87728,
		[
			87728
		]
	],
	"./globe-europe-africa.svg": [
		31166,
		[
			31166
		]
	],
	"./globe.svg": [
		11400,
		[
			11400
		]
	],
	"./globe2.svg": [
		24266,
		[
			24266
		]
	],
	"./google-play.svg": [
		86219,
		[
			86219
		]
	],
	"./google.svg": [
		4276,
		[
			4276
		]
	],
	"./gpu-card.svg": [
		41632,
		[
			41632
		]
	],
	"./graph-down-arrow.svg": [
		7204,
		[
			7204
		]
	],
	"./graph-down.svg": [
		74832,
		[
			74832
		]
	],
	"./graph-up-arrow.svg": [
		38420,
		[
			38420
		]
	],
	"./graph-up.svg": [
		29123,
		[
			29123
		]
	],
	"./grid-1x2-fill.svg": [
		32001,
		[
			32001
		]
	],
	"./grid-1x2.svg": [
		87749,
		[
			87749
		]
	],
	"./grid-3x2-gap-fill.svg": [
		95846,
		[
			95846
		]
	],
	"./grid-3x2-gap.svg": [
		76100,
		[
			76100
		]
	],
	"./grid-3x2.svg": [
		76548,
		[
			76548
		]
	],
	"./grid-3x3-gap-fill.svg": [
		75081,
		[
			75081
		]
	],
	"./grid-3x3-gap.svg": [
		63485,
		[
			63485
		]
	],
	"./grid-3x3.svg": [
		56134,
		[
			56134
		]
	],
	"./grid-fill.svg": [
		59889,
		[
			59889
		]
	],
	"./grid.svg": [
		22453,
		[
			22453
		]
	],
	"./grip-horizontal.svg": [
		36986,
		[
			36986
		]
	],
	"./grip-vertical.svg": [
		5496,
		[
			5496
		]
	],
	"./h-circle-fill.svg": [
		36466,
		[
			36466
		]
	],
	"./h-circle.svg": [
		35256,
		[
			35256
		]
	],
	"./h-square-fill.svg": [
		76197,
		[
			76197
		]
	],
	"./h-square.svg": [
		6625,
		[
			6625
		]
	],
	"./hammer.svg": [
		25875,
		[
			25875
		]
	],
	"./hand-index-fill.svg": [
		67274,
		[
			67274
		]
	],
	"./hand-index-thumb-fill.svg": [
		20832,
		[
			20832
		]
	],
	"./hand-index-thumb.svg": [
		81390,
		[
			81390
		]
	],
	"./hand-index.svg": [
		38057,
		[
			38057
		]
	],
	"./hand-thumbs-down-fill.svg": [
		67253,
		[
			67253
		]
	],
	"./hand-thumbs-down.svg": [
		18833,
		[
			18833
		]
	],
	"./hand-thumbs-up-fill.svg": [
		90752,
		[
			90752
		]
	],
	"./hand-thumbs-up.svg": [
		83118,
		[
			83118
		]
	],
	"./handbag-fill.svg": [
		98870,
		[
			98870
		]
	],
	"./handbag.svg": [
		96564,
		[
			96564
		]
	],
	"./hash.svg": [
		31665,
		[
			31665
		]
	],
	"./hdd-fill.svg": [
		30903,
		[
			30903
		]
	],
	"./hdd-network-fill.svg": [
		62936,
		[
			62936
		]
	],
	"./hdd-network.svg": [
		50710,
		[
			50710
		]
	],
	"./hdd-rack-fill.svg": [
		69977,
		[
			69977
		]
	],
	"./hdd-rack.svg": [
		13901,
		[
			13901
		]
	],
	"./hdd-stack-fill.svg": [
		61790,
		[
			61790
		]
	],
	"./hdd-stack.svg": [
		17612,
		[
			17612
		]
	],
	"./hdd.svg": [
		34651,
		[
			34651
		]
	],
	"./hdmi-fill.svg": [
		27099,
		[
			27099
		]
	],
	"./hdmi.svg": [
		74791,
		[
			74791
		]
	],
	"./headphones.svg": [
		3696,
		[
			3696
		]
	],
	"./headset-vr.svg": [
		93138,
		[
			93138
		]
	],
	"./headset.svg": [
		89741,
		[
			89741
		]
	],
	"./heart-arrow.svg": [
		9519,
		[
			9519
		]
	],
	"./heart-fill.svg": [
		8487,
		[
			8487
		]
	],
	"./heart-half.svg": [
		26855,
		[
			26855
		]
	],
	"./heart-pulse-fill.svg": [
		13299,
		[
			13299
		]
	],
	"./heart-pulse.svg": [
		8815,
		[
			8815
		]
	],
	"./heart.svg": [
		47435,
		[
			47435
		]
	],
	"./heartbreak-fill.svg": [
		85718,
		[
			85718
		]
	],
	"./heartbreak.svg": [
		500,
		[
			500
		]
	],
	"./hearts.svg": [
		59106,
		[
			59106
		]
	],
	"./heptagon-fill.svg": [
		259,
		[
			259
		]
	],
	"./heptagon-half.svg": [
		77915,
		[
			77915
		]
	],
	"./heptagon.svg": [
		22399,
		[
			22399
		]
	],
	"./hexagon-fill.svg": [
		68239,
		[
			68239
		]
	],
	"./hexagon-half.svg": [
		75135,
		[
			75135
		]
	],
	"./hexagon.svg": [
		97379,
		[
			97379
		]
	],
	"./highlighter.svg": [
		62222,
		[
			62222
		]
	],
	"./highlights.svg": [
		97754,
		[
			97754
		]
	],
	"./hospital-fill.svg": [
		97055,
		[
			97055
		]
	],
	"./hospital.svg": [
		45107,
		[
			45107
		]
	],
	"./hourglass-bottom.svg": [
		87539,
		[
			87539
		]
	],
	"./hourglass-split.svg": [
		6054,
		[
			6054
		]
	],
	"./hourglass-top.svg": [
		98871,
		[
			98871
		]
	],
	"./hourglass.svg": [
		56465,
		[
			56465
		]
	],
	"./house-add-fill.svg": [
		63621,
		[
			63621
		]
	],
	"./house-add.svg": [
		79521,
		[
			79521
		]
	],
	"./house-check-fill.svg": [
		94258,
		[
			94258
		]
	],
	"./house-check.svg": [
		65016,
		[
			65016
		]
	],
	"./house-dash-fill.svg": [
		95294,
		[
			95294
		]
	],
	"./house-dash.svg": [
		82124,
		[
			82124
		]
	],
	"./house-door-fill.svg": [
		82458,
		[
			82458
		]
	],
	"./house-door.svg": [
		97424,
		[
			97424
		]
	],
	"./house-down-fill.svg": [
		14302,
		[
			14302
		]
	],
	"./house-down.svg": [
		41036,
		[
			41036
		]
	],
	"./house-exclamation-fill.svg": [
		93703,
		[
			93703
		]
	],
	"./house-exclamation.svg": [
		33067,
		[
			33067
		]
	],
	"./house-fill.svg": [
		6619,
		[
			6619
		]
	],
	"./house-gear-fill.svg": [
		35093,
		[
			35093
		]
	],
	"./house-gear.svg": [
		21265,
		[
			21265
		]
	],
	"./house-heart-fill.svg": [
		12526,
		[
			12526
		]
	],
	"./house-heart.svg": [
		47132,
		[
			47132
		]
	],
	"./house-lock-fill.svg": [
		78033,
		[
			78033
		]
	],
	"./house-lock.svg": [
		46101,
		[
			46101
		]
	],
	"./house-slash-fill.svg": [
		61311,
		[
			61311
		]
	],
	"./house-slash.svg": [
		13395,
		[
			13395
		]
	],
	"./house-up-fill.svg": [
		71912,
		[
			71912
		]
	],
	"./house-up.svg": [
		2215,
		[
			2215
		]
	],
	"./house-x-fill.svg": [
		4066,
		[
			4066
		]
	],
	"./house-x.svg": [
		32168,
		[
			32168
		]
	],
	"./house.svg": [
		9031,
		[
			9031
		]
	],
	"./houses-fill.svg": [
		27992,
		[
			27992
		]
	],
	"./houses.svg": [
		4342,
		[
			4342
		]
	],
	"./hr.svg": [
		82915,
		[
			82915
		]
	],
	"./hurricane.svg": [
		24722,
		[
			24722
		]
	],
	"./hypnotize.svg": [
		81931,
		[
			81931
		]
	],
	"./image-alt.svg": [
		478,
		[
			478
		]
	],
	"./image-fill.svg": [
		9922,
		[
			9922
		]
	],
	"./image.svg": [
		41672,
		[
			41672
		]
	],
	"./images.svg": [
		83675,
		[
			83675
		]
	],
	"./inbox-fill.svg": [
		12271,
		[
			12271
		]
	],
	"./inbox.svg": [
		68067,
		[
			68067
		]
	],
	"./inboxes-fill.svg": [
		96339,
		[
			96339
		]
	],
	"./inboxes.svg": [
		93231,
		[
			93231
		]
	],
	"./incognito.svg": [
		72993,
		[
			72993
		]
	],
	"./indent.svg": [
		68459,
		[
			68459
		]
	],
	"./infinity.svg": [
		20977,
		[
			20977
		]
	],
	"./info-circle-fill.svg": [
		81036,
		[
			81036
		]
	],
	"./info-circle.svg": [
		52770,
		[
			52770
		]
	],
	"./info-lg.svg": [
		21665,
		[
			21665
		]
	],
	"./info-square-fill.svg": [
		98459,
		[
			98459
		]
	],
	"./info-square.svg": [
		64039,
		[
			64039
		]
	],
	"./info.svg": [
		43381,
		[
			43381
		]
	],
	"./input-cursor-text.svg": [
		21758,
		[
			21758
		]
	],
	"./input-cursor.svg": [
		32354,
		[
			32354
		]
	],
	"./instagram.svg": [
		27815,
		[
			27815
		]
	],
	"./intersect.svg": [
		63672,
		[
			63672
		]
	],
	"./javascript.svg": [
		70748,
		[
			70748
		]
	],
	"./journal-album.svg": [
		19396,
		[
			19396
		]
	],
	"./journal-arrow-down.svg": [
		69507,
		[
			69507
		]
	],
	"./journal-arrow-up.svg": [
		78428,
		[
			78428
		]
	],
	"./journal-bookmark-fill.svg": [
		14407,
		[
			14407
		]
	],
	"./journal-bookmark.svg": [
		63947,
		[
			63947
		]
	],
	"./journal-check.svg": [
		45261,
		[
			45261
		]
	],
	"./journal-code.svg": [
		43724,
		[
			43724
		]
	],
	"./journal-medical.svg": [
		32196,
		[
			32196
		]
	],
	"./journal-minus.svg": [
		24709,
		[
			24709
		]
	],
	"./journal-plus.svg": [
		95943,
		[
			95943
		]
	],
	"./journal-richtext.svg": [
		87192,
		[
			87192
		]
	],
	"./journal-text.svg": [
		66674,
		[
			66674
		]
	],
	"./journal-x.svg": [
		68765,
		[
			68765
		]
	],
	"./journal.svg": [
		45134,
		[
			45134
		]
	],
	"./journals.svg": [
		21777,
		[
			21777
		]
	],
	"./joystick.svg": [
		83539,
		[
			83539
		]
	],
	"./justify-left.svg": [
		71987,
		[
			71987
		]
	],
	"./justify-right.svg": [
		37142,
		[
			37142
		]
	],
	"./justify.svg": [
		91695,
		[
			91695
		]
	],
	"./kanban-fill.svg": [
		97974,
		[
			97974
		]
	],
	"./kanban.svg": [
		93844,
		[
			93844
		]
	],
	"./key-fill.svg": [
		96456,
		[
			96456
		]
	],
	"./key.svg": [
		61606,
		[
			61606
		]
	],
	"./keyboard-fill.svg": [
		32424,
		[
			32424
		]
	],
	"./keyboard.svg": [
		82790,
		[
			82790
		]
	],
	"./ladder.svg": [
		54713,
		[
			54713
		]
	],
	"./lamp-fill.svg": [
		99191,
		[
			99191
		]
	],
	"./lamp.svg": [
		48187,
		[
			48187
		]
	],
	"./laptop-fill.svg": [
		40473,
		[
			40473
		]
	],
	"./laptop.svg": [
		94298,
		[
			94298
		]
	],
	"./layer-backward.svg": [
		20178,
		[
			20178
		]
	],
	"./layer-forward.svg": [
		66984,
		[
			66984
		]
	],
	"./layers-fill.svg": [
		9803,
		[
			9803
		]
	],
	"./layers-half.svg": [
		21299,
		[
			21299
		]
	],
	"./layers.svg": [
		48375,
		[
			48375
		]
	],
	"./layout-sidebar-inset-reverse.svg": [
		11717,
		[
			11717
		]
	],
	"./layout-sidebar-inset.svg": [
		8044,
		[
			8044
		]
	],
	"./layout-sidebar-reverse.svg": [
		39401,
		[
			39401
		]
	],
	"./layout-sidebar.svg": [
		15176,
		[
			15176
		]
	],
	"./layout-split.svg": [
		87396,
		[
			87396
		]
	],
	"./layout-text-sidebar-reverse.svg": [
		94747,
		[
			94747
		]
	],
	"./layout-text-sidebar.svg": [
		18170,
		[
			18170
		]
	],
	"./layout-text-window-reverse.svg": [
		4139,
		[
			4139
		]
	],
	"./layout-text-window.svg": [
		74026,
		[
			74026
		]
	],
	"./layout-three-columns.svg": [
		37970,
		[
			37970
		]
	],
	"./layout-wtf.svg": [
		32825,
		[
			32825
		]
	],
	"./leaf-fill.svg": [
		57073,
		[
			57073
		]
	],
	"./leaf.svg": [
		87733,
		[
			87733
		]
	],
	"./life-preserver.svg": [
		80198,
		[
			80198
		]
	],
	"./lightbulb-fill.svg": [
		36200,
		[
			36200
		]
	],
	"./lightbulb-off-fill.svg": [
		59016,
		[
			59016
		]
	],
	"./lightbulb-off.svg": [
		54630,
		[
			54630
		]
	],
	"./lightbulb.svg": [
		90534,
		[
			90534
		]
	],
	"./lightning-charge-fill.svg": [
		31652,
		[
			31652
		]
	],
	"./lightning-charge.svg": [
		44106,
		[
			44106
		]
	],
	"./lightning-fill.svg": [
		78369,
		[
			78369
		]
	],
	"./lightning.svg": [
		36997,
		[
			36997
		]
	],
	"./line.svg": [
		61587,
		[
			61587
		]
	],
	"./link-45deg.svg": [
		92617,
		[
			92617
		]
	],
	"./link.svg": [
		77765,
		[
			77765
		]
	],
	"./linkedin.svg": [
		82803,
		[
			82803
		]
	],
	"./list-check.svg": [
		49086,
		[
			49086
		]
	],
	"./list-columns-reverse.svg": [
		8406,
		[
			8406
		]
	],
	"./list-columns.svg": [
		73907,
		[
			73907
		]
	],
	"./list-nested.svg": [
		64135,
		[
			64135
		]
	],
	"./list-ol.svg": [
		64891,
		[
			64891
		]
	],
	"./list-stars.svg": [
		40825,
		[
			40825
		]
	],
	"./list-task.svg": [
		92957,
		[
			92957
		]
	],
	"./list-ul.svg": [
		28313,
		[
			28313
		]
	],
	"./list.svg": [
		95481,
		[
			95481
		]
	],
	"./lock-fill.svg": [
		69102,
		[
			69102
		]
	],
	"./lock.svg": [
		48956,
		[
			48956
		]
	],
	"./luggage-fill.svg": [
		2599,
		[
			2599
		]
	],
	"./luggage.svg": [
		9867,
		[
			9867
		]
	],
	"./lungs-fill.svg": [
		3286,
		[
			3286
		]
	],
	"./lungs.svg": [
		96244,
		[
			96244
		]
	],
	"./magic.svg": [
		47202,
		[
			47202
		]
	],
	"./magnet-fill.svg": [
		9715,
		[
			9715
		]
	],
	"./magnet.svg": [
		52431,
		[
			52431
		]
	],
	"./mailbox-flag.svg": [
		58918,
		[
			58918
		]
	],
	"./mailbox.svg": [
		78703,
		[
			78703
		]
	],
	"./mailbox2-flag.svg": [
		29046,
		[
			29046
		]
	],
	"./mailbox2.svg": [
		90207,
		[
			90207
		]
	],
	"./map-fill.svg": [
		51301,
		[
			51301
		]
	],
	"./map.svg": [
		25729,
		[
			25729
		]
	],
	"./markdown-fill.svg": [
		22308,
		[
			22308
		]
	],
	"./markdown.svg": [
		55882,
		[
			33501
		]
	],
	"./marker-tip.svg": [
		84187,
		[
			84187
		]
	],
	"./mask.svg": [
		79829,
		[
			79829
		]
	],
	"./mastodon.svg": [
		7016,
		[
			7016
		]
	],
	"./measuring-cup-fill.svg": [
		26617,
		[
			26617
		]
	],
	"./measuring-cup.svg": [
		58029,
		[
			58029
		]
	],
	"./medium.svg": [
		54540,
		[
			54540
		]
	],
	"./megaphone-fill.svg": [
		65569,
		[
			65569
		]
	],
	"./megaphone.svg": [
		89061,
		[
			89061
		]
	],
	"./memory.svg": [
		85260,
		[
			85260
		]
	],
	"./menu-app-fill.svg": [
		21348,
		[
			21348
		]
	],
	"./menu-app.svg": [
		25258,
		[
			25258
		]
	],
	"./menu-button-fill.svg": [
		98709,
		[
			98709
		]
	],
	"./menu-button-wide-fill.svg": [
		64571,
		[
			64571
		]
	],
	"./menu-button-wide.svg": [
		8871,
		[
			8871
		]
	],
	"./menu-button.svg": [
		23633,
		[
			23633
		]
	],
	"./menu-down.svg": [
		18229,
		[
			18229
		]
	],
	"./menu-up.svg": [
		23354,
		[
			23354
		]
	],
	"./messenger.svg": [
		52582,
		[
			52582
		]
	],
	"./meta.svg": [
		92202,
		[
			92202
		]
	],
	"./mic-fill.svg": [
		17236,
		[
			17236
		]
	],
	"./mic-mute-fill.svg": [
		86018,
		[
			86018
		]
	],
	"./mic-mute.svg": [
		9544,
		[
			9544
		]
	],
	"./mic.svg": [
		9786,
		[
			9786
		]
	],
	"./microsoft-teams.svg": [
		59958,
		[
			59958
		]
	],
	"./microsoft.svg": [
		98547,
		[
			98547
		]
	],
	"./minecart-loaded.svg": [
		92060,
		[
			92060
		]
	],
	"./minecart.svg": [
		3261,
		[
			25642
		]
	],
	"./modem-fill.svg": [
		65285,
		[
			65285
		]
	],
	"./modem.svg": [
		73537,
		[
			73537
		]
	],
	"./moisture.svg": [
		36147,
		[
			36147
		]
	],
	"./moon-fill.svg": [
		53192,
		[
			53192
		]
	],
	"./moon-stars-fill.svg": [
		64844,
		[
			64844
		]
	],
	"./moon-stars.svg": [
		43586,
		[
			43586
		]
	],
	"./moon.svg": [
		72966,
		[
			72966
		]
	],
	"./mortarboard-fill.svg": [
		52764,
		[
			52764
		]
	],
	"./mortarboard.svg": [
		88050,
		[
			88050
		]
	],
	"./motherboard-fill.svg": [
		9058,
		[
			9058
		]
	],
	"./motherboard.svg": [
		90344,
		[
			90344
		]
	],
	"./mouse-fill.svg": [
		61932,
		[
			61932
		]
	],
	"./mouse.svg": [
		87362,
		[
			87362
		]
	],
	"./mouse2-fill.svg": [
		21070,
		[
			21070
		]
	],
	"./mouse2.svg": [
		74588,
		[
			74588
		]
	],
	"./mouse3-fill.svg": [
		55849,
		[
			55849
		]
	],
	"./mouse3.svg": [
		3133,
		[
			3133
		]
	],
	"./music-note-beamed.svg": [
		59758,
		[
			59758
		]
	],
	"./music-note-list.svg": [
		65244,
		[
			65244
		]
	],
	"./music-note.svg": [
		14955,
		[
			14955
		]
	],
	"./music-player-fill.svg": [
		77798,
		[
			77798
		]
	],
	"./music-player.svg": [
		31492,
		[
			31492
		]
	],
	"./newspaper.svg": [
		63790,
		[
			63790
		]
	],
	"./nintendo-switch.svg": [
		69111,
		[
			69111
		]
	],
	"./node-minus-fill.svg": [
		44492,
		[
			44492
		]
	],
	"./node-minus.svg": [
		96066,
		[
			96066
		]
	],
	"./node-plus-fill.svg": [
		51972,
		[
			51972
		]
	],
	"./node-plus.svg": [
		33898,
		[
			33898
		]
	],
	"./noise-reduction.svg": [
		93529,
		[
			93529
		]
	],
	"./nut-fill.svg": [
		27500,
		[
			27500
		]
	],
	"./nut.svg": [
		56162,
		[
			56162
		]
	],
	"./nvidia.svg": [
		87244,
		[
			87244
		]
	],
	"./nvme-fill.svg": [
		72203,
		[
			72203
		]
	],
	"./nvme.svg": [
		38039,
		[
			38039
		]
	],
	"./octagon-fill.svg": [
		91668,
		[
			69287
		]
	],
	"./octagon-half.svg": [
		14968,
		[
			14968
		]
	],
	"./octagon.svg": [
		95002,
		[
			95002
		]
	],
	"./openai.svg": [
		38371,
		[
			38371
		]
	],
	"./opencollective.svg": [
		83133,
		[
			83133
		]
	],
	"./optical-audio-fill.svg": [
		20936,
		[
			20936
		]
	],
	"./optical-audio.svg": [
		11686,
		[
			11686
		]
	],
	"./option.svg": [
		95082,
		[
			95082
		]
	],
	"./outlet.svg": [
		52470,
		[
			52470
		]
	],
	"./p-circle-fill.svg": [
		89274,
		[
			89274
		]
	],
	"./p-circle.svg": [
		8016,
		[
			8016
		]
	],
	"./p-square-fill.svg": [
		64525,
		[
			64525
		]
	],
	"./p-square.svg": [
		21049,
		[
			21049
		]
	],
	"./paint-bucket.svg": [
		3934,
		[
			3934
		]
	],
	"./palette-fill.svg": [
		43928,
		[
			43928
		]
	],
	"./palette.svg": [
		29174,
		[
			29174
		]
	],
	"./palette2.svg": [
		46616,
		[
			46616
		]
	],
	"./paperclip.svg": [
		97523,
		[
			97523
		]
	],
	"./paragraph.svg": [
		91149,
		[
			91149
		]
	],
	"./pass-fill.svg": [
		25532,
		[
			25532
		]
	],
	"./pass.svg": [
		65637,
		[
			88018
		]
	],
	"./passport-fill.svg": [
		10391,
		[
			10391
		]
	],
	"./passport.svg": [
		51163,
		[
			51163
		]
	],
	"./patch-check-fill.svg": [
		45636,
		[
			45636
		]
	],
	"./patch-check.svg": [
		33501,
		[
			55882
		]
	],
	"./patch-exclamation-fill.svg": [
		31257,
		[
			31257
		]
	],
	"./patch-exclamation.svg": [
		57133,
		[
			57133
		]
	],
	"./patch-minus-fill.svg": [
		61816,
		[
			61816
		]
	],
	"./patch-minus.svg": [
		45782,
		[
			45782
		]
	],
	"./patch-plus-fill.svg": [
		63120,
		[
			63120
		]
	],
	"./patch-plus.svg": [
		30142,
		[
			30142
		]
	],
	"./patch-question-fill.svg": [
		69908,
		[
			69908
		]
	],
	"./patch-question.svg": [
		87642,
		[
			87642
		]
	],
	"./pause-btn-fill.svg": [
		7516,
		[
			7516
		]
	],
	"./pause-btn.svg": [
		5106,
		[
			5106
		]
	],
	"./pause-circle-fill.svg": [
		26168,
		[
			26168
		]
	],
	"./pause-circle.svg": [
		19798,
		[
			19798
		]
	],
	"./pause-fill.svg": [
		56269,
		[
			56269
		]
	],
	"./pause.svg": [
		24985,
		[
			24985
		]
	],
	"./paypal.svg": [
		36604,
		[
			36604
		]
	],
	"./pc-display-horizontal.svg": [
		10204,
		[
			10204
		]
	],
	"./pc-display.svg": [
		66763,
		[
			66763
		]
	],
	"./pc-horizontal.svg": [
		17167,
		[
			17167
		]
	],
	"./pc.svg": [
		45322,
		[
			45322
		]
	],
	"./pci-card-network.svg": [
		9595,
		[
			9595
		]
	],
	"./pci-card-sound.svg": [
		73464,
		[
			73464
		]
	],
	"./pci-card.svg": [
		97842,
		[
			97842
		]
	],
	"./peace-fill.svg": [
		99413,
		[
			99413
		]
	],
	"./peace.svg": [
		68273,
		[
			68273
		]
	],
	"./pen-fill.svg": [
		9508,
		[
			9508
		]
	],
	"./pen.svg": [
		70442,
		[
			70442
		]
	],
	"./pencil-fill.svg": [
		95280,
		[
			95280
		]
	],
	"./pencil-square.svg": [
		58074,
		[
			58074
		]
	],
	"./pencil.svg": [
		75166,
		[
			75166
		]
	],
	"./pentagon-fill.svg": [
		46129,
		[
			46129
		]
	],
	"./pentagon-half.svg": [
		94153,
		[
			94153
		]
	],
	"./pentagon.svg": [
		2581,
		[
			2581
		]
	],
	"./people-fill.svg": [
		93730,
		[
			93730
		]
	],
	"./people.svg": [
		24168,
		[
			24168
		]
	],
	"./percent.svg": [
		63296,
		[
			63296
		]
	],
	"./perplexity.svg": [
		37415,
		[
			37415
		]
	],
	"./person-add.svg": [
		74048,
		[
			74048
		]
	],
	"./person-arms-up.svg": [
		79052,
		[
			79052
		]
	],
	"./person-badge-fill.svg": [
		76046,
		[
			76046
		]
	],
	"./person-badge.svg": [
		69948,
		[
			69948
		]
	],
	"./person-bounding-box.svg": [
		86039,
		[
			86039
		]
	],
	"./person-check-fill.svg": [
		33917,
		[
			33917
		]
	],
	"./person-check.svg": [
		24841,
		[
			24841
		]
	],
	"./person-circle.svg": [
		94455,
		[
			94455
		]
	],
	"./person-dash-fill.svg": [
		49687,
		[
			49687
		]
	],
	"./person-dash.svg": [
		57435,
		[
			57435
		]
	],
	"./person-down.svg": [
		66051,
		[
			66051
		]
	],
	"./person-exclamation.svg": [
		55118,
		[
			55118
		]
	],
	"./person-fill-add.svg": [
		36602,
		[
			36602
		]
	],
	"./person-fill-check.svg": [
		82455,
		[
			82455
		]
	],
	"./person-fill-dash.svg": [
		39557,
		[
			39557
		]
	],
	"./person-fill-down.svg": [
		20757,
		[
			20757
		]
	],
	"./person-fill-exclamation.svg": [
		8068,
		[
			8068
		]
	],
	"./person-fill-gear.svg": [
		26348,
		[
			26348
		]
	],
	"./person-fill-lock.svg": [
		21988,
		[
			21988
		]
	],
	"./person-fill-slash.svg": [
		68652,
		[
			68652
		]
	],
	"./person-fill-up.svg": [
		54330,
		[
			54330
		]
	],
	"./person-fill-x.svg": [
		7427,
		[
			7427
		]
	],
	"./person-fill.svg": [
		30052,
		[
			30052
		]
	],
	"./person-gear.svg": [
		34334,
		[
			34334
		]
	],
	"./person-heart.svg": [
		65885,
		[
			65885
		]
	],
	"./person-hearts.svg": [
		91636,
		[
			91636
		]
	],
	"./person-lines-fill.svg": [
		22586,
		[
			22586
		]
	],
	"./person-lock.svg": [
		66386,
		[
			66386
		]
	],
	"./person-plus-fill.svg": [
		25535,
		[
			25535
		]
	],
	"./person-plus.svg": [
		51251,
		[
			51251
		]
	],
	"./person-raised-hand.svg": [
		87735,
		[
			87735
		]
	],
	"./person-rolodex.svg": [
		20948,
		[
			20948
		]
	],
	"./person-slash.svg": [
		97898,
		[
			97898
		]
	],
	"./person-square.svg": [
		14886,
		[
			14886
		]
	],
	"./person-standing-dress.svg": [
		4709,
		[
			4709
		]
	],
	"./person-standing.svg": [
		21739,
		[
			21739
		]
	],
	"./person-up.svg": [
		44860,
		[
			44860
		]
	],
	"./person-vcard-fill.svg": [
		52577,
		[
			52577
		]
	],
	"./person-vcard.svg": [
		26885,
		[
			26885
		]
	],
	"./person-video.svg": [
		74920,
		[
			74920
		]
	],
	"./person-video2.svg": [
		36842,
		[
			36842
		]
	],
	"./person-video3.svg": [
		97211,
		[
			97211
		]
	],
	"./person-walking.svg": [
		52276,
		[
			52276
		]
	],
	"./person-wheelchair.svg": [
		73359,
		[
			73359
		]
	],
	"./person-workspace.svg": [
		73830,
		[
			73830
		]
	],
	"./person-x-fill.svg": [
		62773,
		[
			62773
		]
	],
	"./person-x.svg": [
		11505,
		[
			11505
		]
	],
	"./person.svg": [
		74474,
		[
			74474
		]
	],
	"./phone-fill.svg": [
		97847,
		[
			97847
		]
	],
	"./phone-flip.svg": [
		15981,
		[
			15981
		]
	],
	"./phone-landscape-fill.svg": [
		34487,
		[
			34487
		]
	],
	"./phone-landscape.svg": [
		84347,
		[
			84347
		]
	],
	"./phone-vibrate-fill.svg": [
		74585,
		[
			74585
		]
	],
	"./phone-vibrate.svg": [
		86893,
		[
			86893
		]
	],
	"./phone.svg": [
		54043,
		[
			54043
		]
	],
	"./pie-chart-fill.svg": [
		90840,
		[
			90840
		]
	],
	"./pie-chart.svg": [
		99414,
		[
			99414
		]
	],
	"./piggy-bank-fill.svg": [
		69204,
		[
			69204
		]
	],
	"./piggy-bank.svg": [
		55194,
		[
			55194
		]
	],
	"./pin-angle-fill.svg": [
		76994,
		[
			76994
		]
	],
	"./pin-angle.svg": [
		45064,
		[
			45064
		]
	],
	"./pin-fill.svg": [
		89336,
		[
			89336
		]
	],
	"./pin-map-fill.svg": [
		9431,
		[
			9431
		]
	],
	"./pin-map.svg": [
		82427,
		[
			82427
		]
	],
	"./pin.svg": [
		25174,
		[
			25174
		]
	],
	"./pinterest.svg": [
		78621,
		[
			78621
		]
	],
	"./pip-fill.svg": [
		68490,
		[
			68490
		]
	],
	"./pip.svg": [
		84672,
		[
			84672
		]
	],
	"./play-btn-fill.svg": [
		98414,
		[
			98414
		]
	],
	"./play-btn.svg": [
		93340,
		[
			93340
		]
	],
	"./play-circle-fill.svg": [
		6378,
		[
			6378
		]
	],
	"./play-circle.svg": [
		32128,
		[
			32128
		]
	],
	"./play-fill.svg": [
		72015,
		[
			72015
		]
	],
	"./play.svg": [
		91107,
		[
			91107
		]
	],
	"./playstation.svg": [
		11885,
		[
			11885
		]
	],
	"./plug-fill.svg": [
		30397,
		[
			30397
		]
	],
	"./plug.svg": [
		48297,
		[
			48297
		]
	],
	"./plugin.svg": [
		18904,
		[
			18904
		]
	],
	"./plus-circle-dotted.svg": [
		57043,
		[
			57043
		]
	],
	"./plus-circle-fill.svg": [
		83788,
		[
			83788
		]
	],
	"./plus-circle.svg": [
		62882,
		[
			62882
		]
	],
	"./plus-lg.svg": [
		90273,
		[
			90273
		]
	],
	"./plus-slash-minus.svg": [
		88370,
		[
			88370
		]
	],
	"./plus-square-dotted.svg": [
		79952,
		[
			79952
		]
	],
	"./plus-square-fill.svg": [
		45083,
		[
			45083
		]
	],
	"./plus-square.svg": [
		85031,
		[
			85031
		]
	],
	"./plus.svg": [
		52309,
		[
			52309
		]
	],
	"./postage-fill.svg": [
		20734,
		[
			20734
		]
	],
	"./postage-heart-fill.svg": [
		6087,
		[
			6087
		]
	],
	"./postage-heart.svg": [
		42059,
		[
			42059
		]
	],
	"./postage.svg": [
		14668,
		[
			14668
		]
	],
	"./postcard-fill.svg": [
		93193,
		[
			93193
		]
	],
	"./postcard-heart-fill.svg": [
		51040,
		[
			51040
		]
	],
	"./postcard-heart.svg": [
		87822,
		[
			87822
		]
	],
	"./postcard.svg": [
		47613,
		[
			47613
		]
	],
	"./power.svg": [
		40036,
		[
			40036
		]
	],
	"./prescription.svg": [
		87777,
		[
			87777
		]
	],
	"./prescription2.svg": [
		47393,
		[
			47393
		]
	],
	"./printer-fill.svg": [
		29315,
		[
			29315
		]
	],
	"./printer.svg": [
		15263,
		[
			15263
		]
	],
	"./projector-fill.svg": [
		20699,
		[
			20699
		]
	],
	"./projector.svg": [
		83687,
		[
			83687
		]
	],
	"./puzzle-fill.svg": [
		27029,
		[
			27029
		]
	],
	"./puzzle.svg": [
		82929,
		[
			82929
		]
	],
	"./qr-code-scan.svg": [
		89176,
		[
			89176
		]
	],
	"./qr-code.svg": [
		52406,
		[
			52406
		]
	],
	"./question-circle-fill.svg": [
		41548,
		[
			41548
		]
	],
	"./question-circle.svg": [
		32066,
		[
			32066
		]
	],
	"./question-diamond-fill.svg": [
		74420,
		[
			74420
		]
	],
	"./question-diamond.svg": [
		75322,
		[
			75322
		]
	],
	"./question-lg.svg": [
		67937,
		[
			67937
		]
	],
	"./question-octagon-fill.svg": [
		40879,
		[
			40879
		]
	],
	"./question-octagon.svg": [
		56867,
		[
			56867
		]
	],
	"./question-square-fill.svg": [
		90907,
		[
			90907
		]
	],
	"./question-square.svg": [
		43047,
		[
			43047
		]
	],
	"./question.svg": [
		30293,
		[
			30293
		]
	],
	"./quora.svg": [
		41649,
		[
			41649
		]
	],
	"./quote.svg": [
		92367,
		[
			92367
		]
	],
	"./r-circle-fill.svg": [
		7680,
		[
			7680
		]
	],
	"./r-circle.svg": [
		2254,
		[
			2254
		]
	],
	"./r-square-fill.svg": [
		86159,
		[
			86159
		]
	],
	"./r-square.svg": [
		96771,
		[
			96771
		]
	],
	"./radar.svg": [
		1919,
		[
			1919
		]
	],
	"./radioactive.svg": [
		46160,
		[
			46160
		]
	],
	"./rainbow.svg": [
		23701,
		[
			23701
		]
	],
	"./receipt-cutoff.svg": [
		79927,
		[
			79927
		]
	],
	"./receipt.svg": [
		85663,
		[
			85663
		]
	],
	"./reception-0.svg": [
		5495,
		[
			5495
		]
	],
	"./reception-1.svg": [
		166,
		[
			166
		]
	],
	"./reception-2.svg": [
		48293,
		[
			48293
		]
	],
	"./reception-3.svg": [
		51044,
		[
			51044
		]
	],
	"./reception-4.svg": [
		18635,
		[
			18635
		]
	],
	"./record-btn-fill.svg": [
		7689,
		[
			7689
		]
	],
	"./record-btn.svg": [
		75645,
		[
			75645
		]
	],
	"./record-circle-fill.svg": [
		75063,
		[
			75063
		]
	],
	"./record-circle.svg": [
		79643,
		[
			79643
		]
	],
	"./record-fill.svg": [
		91312,
		[
			91312
		]
	],
	"./record.svg": [
		70430,
		[
			70430
		]
	],
	"./record2-fill.svg": [
		73178,
		[
			73178
		]
	],
	"./record2.svg": [
		27024,
		[
			27024
		]
	],
	"./recycle.svg": [
		78684,
		[
			78684
		]
	],
	"./reddit.svg": [
		40237,
		[
			40237
		]
	],
	"./regex.svg": [
		89982,
		[
			89982
		]
	],
	"./repeat-1.svg": [
		19370,
		[
			19370
		]
	],
	"./repeat.svg": [
		16228,
		[
			16228
		]
	],
	"./reply-all-fill.svg": [
		66621,
		[
			66621
		]
	],
	"./reply-all.svg": [
		68393,
		[
			68393
		]
	],
	"./reply-fill.svg": [
		70099,
		[
			70099
		]
	],
	"./reply.svg": [
		44271,
		[
			44271
		]
	],
	"./rewind-btn-fill.svg": [
		65275,
		[
			65275
		]
	],
	"./rewind-btn.svg": [
		20071,
		[
			20071
		]
	],
	"./rewind-circle-fill.svg": [
		59049,
		[
			59049
		]
	],
	"./rewind-circle.svg": [
		72957,
		[
			72957
		]
	],
	"./rewind-fill.svg": [
		60218,
		[
			60218
		]
	],
	"./rewind.svg": [
		47056,
		[
			47056
		]
	],
	"./robot.svg": [
		56563,
		[
			56563
		]
	],
	"./rocket-fill.svg": [
		62701,
		[
			62701
		]
	],
	"./rocket-takeoff-fill.svg": [
		12836,
		[
			12836
		]
	],
	"./rocket-takeoff.svg": [
		69322,
		[
			69322
		]
	],
	"./rocket.svg": [
		68409,
		[
			68409
		]
	],
	"./router-fill.svg": [
		58428,
		[
			58428
		]
	],
	"./router.svg": [
		63602,
		[
			63602
		]
	],
	"./rss-fill.svg": [
		5135,
		[
			5135
		]
	],
	"./rss.svg": [
		41059,
		[
			41059
		]
	],
	"./rulers.svg": [
		20150,
		[
			20150
		]
	],
	"./safe-fill.svg": [
		15732,
		[
			15732
		]
	],
	"./safe.svg": [
		88858,
		[
			88858
		]
	],
	"./safe2-fill.svg": [
		36582,
		[
			36582
		]
	],
	"./safe2.svg": [
		37796,
		[
			37796
		]
	],
	"./save-fill.svg": [
		74468,
		[
			74468
		]
	],
	"./save.svg": [
		60042,
		[
			60042
		]
	],
	"./save2-fill.svg": [
		3638,
		[
			3638
		]
	],
	"./save2.svg": [
		78420,
		[
			78420
		]
	],
	"./scissors.svg": [
		53360,
		[
			53360
		]
	],
	"./scooter.svg": [
		57070,
		[
			57070
		]
	],
	"./screwdriver.svg": [
		84417,
		[
			84417
		]
	],
	"./sd-card-fill.svg": [
		99811,
		[
			99811
		]
	],
	"./sd-card.svg": [
		3743,
		[
			3743
		]
	],
	"./search-heart-fill.svg": [
		95356,
		[
			72975
		]
	],
	"./search-heart.svg": [
		17170,
		[
			17170
		]
	],
	"./search.svg": [
		47433,
		[
			47433
		]
	],
	"./segmented-nav.svg": [
		86815,
		[
			86815
		]
	],
	"./send-arrow-down-fill.svg": [
		45501,
		[
			67882
		]
	],
	"./send-arrow-down.svg": [
		90624,
		[
			90624
		]
	],
	"./send-arrow-up-fill.svg": [
		37727,
		[
			37727
		]
	],
	"./send-arrow-up.svg": [
		25523,
		[
			25523
		]
	],
	"./send-check-fill.svg": [
		13738,
		[
			13738
		]
	],
	"./send-check.svg": [
		74624,
		[
			74624
		]
	],
	"./send-dash-fill.svg": [
		46006,
		[
			46006
		]
	],
	"./send-dash.svg": [
		59636,
		[
			59636
		]
	],
	"./send-exclamation-fill.svg": [
		66175,
		[
			66175
		]
	],
	"./send-exclamation.svg": [
		84211,
		[
			84211
		]
	],
	"./send-fill.svg": [
		4291,
		[
			4291
		]
	],
	"./send-plus-fill.svg": [
		98050,
		[
			98050
		]
	],
	"./send-plus.svg": [
		99592,
		[
			99592
		]
	],
	"./send-slash-fill.svg": [
		72279,
		[
			72279
		]
	],
	"./send-slash.svg": [
		37115,
		[
			37115
		]
	],
	"./send-x-fill.svg": [
		38474,
		[
			38474
		]
	],
	"./send-x.svg": [
		23936,
		[
			23936
		]
	],
	"./send.svg": [
		69567,
		[
			69567
		]
	],
	"./server.svg": [
		18128,
		[
			18128
		]
	],
	"./shadows.svg": [
		99728,
		[
			99728
		]
	],
	"./share-fill.svg": [
		71656,
		[
			71656
		]
	],
	"./share.svg": [
		1990,
		[
			1990
		]
	],
	"./shield-check.svg": [
		74405,
		[
			74405
		]
	],
	"./shield-exclamation.svg": [
		42306,
		[
			42306
		]
	],
	"./shield-fill-check.svg": [
		43611,
		[
			43611
		]
	],
	"./shield-fill-exclamation.svg": [
		12272,
		[
			12272
		]
	],
	"./shield-fill-minus.svg": [
		18335,
		[
			18335
		]
	],
	"./shield-fill-plus.svg": [
		47025,
		[
			47025
		]
	],
	"./shield-fill-x.svg": [
		86831,
		[
			86831
		]
	],
	"./shield-fill.svg": [
		97656,
		[
			97656
		]
	],
	"./shield-lock-fill.svg": [
		62336,
		[
			62336
		]
	],
	"./shield-lock.svg": [
		14798,
		[
			14798
		]
	],
	"./shield-minus.svg": [
		40845,
		[
			40845
		]
	],
	"./shield-plus.svg": [
		87999,
		[
			87999
		]
	],
	"./shield-shaded.svg": [
		95638,
		[
			95638
		]
	],
	"./shield-slash-fill.svg": [
		82936,
		[
			82936
		]
	],
	"./shield-slash.svg": [
		30422,
		[
			30422
		]
	],
	"./shield-x.svg": [
		92837,
		[
			92837
		]
	],
	"./shield.svg": [
		44054,
		[
			44054
		]
	],
	"./shift-fill.svg": [
		91527,
		[
			91527
		]
	],
	"./shift.svg": [
		26520,
		[
			26520
		]
	],
	"./shop-window.svg": [
		93446,
		[
			93446
		]
	],
	"./shop.svg": [
		62765,
		[
			62765
		]
	],
	"./shuffle.svg": [
		58756,
		[
			58756
		]
	],
	"./sign-dead-end-fill.svg": [
		20257,
		[
			20257
		]
	],
	"./sign-dead-end.svg": [
		75685,
		[
			75685
		]
	],
	"./sign-do-not-enter-fill.svg": [
		98997,
		[
			98997
		]
	],
	"./sign-do-not-enter.svg": [
		79454,
		[
			79454
		]
	],
	"./sign-intersection-fill.svg": [
		77590,
		[
			77590
		]
	],
	"./sign-intersection-side-fill.svg": [
		64042,
		[
			64042
		]
	],
	"./sign-intersection-side.svg": [
		54048,
		[
			54048
		]
	],
	"./sign-intersection-t-fill.svg": [
		587,
		[
			587
		]
	],
	"./sign-intersection-t.svg": [
		86519,
		[
			86519
		]
	],
	"./sign-intersection-y-fill.svg": [
		55212,
		[
			55212
		]
	],
	"./sign-intersection-y.svg": [
		57826,
		[
			57826
		]
	],
	"./sign-intersection.svg": [
		42164,
		[
			42164
		]
	],
	"./sign-merge-left-fill.svg": [
		73297,
		[
			73297
		]
	],
	"./sign-merge-left.svg": [
		50613,
		[
			50613
		]
	],
	"./sign-merge-right-fill.svg": [
		70738,
		[
			70738
		]
	],
	"./sign-merge-right.svg": [
		49624,
		[
			49624
		]
	],
	"./sign-no-left-turn-fill.svg": [
		84682,
		[
			84682
		]
	],
	"./sign-no-left-turn.svg": [
		8224,
		[
			8224
		]
	],
	"./sign-no-parking-fill.svg": [
		18613,
		[
			18613
		]
	],
	"./sign-no-parking.svg": [
		19761,
		[
			19761
		]
	],
	"./sign-no-right-turn-fill.svg": [
		27805,
		[
			27805
		]
	],
	"./sign-no-right-turn.svg": [
		69910,
		[
			69910
		]
	],
	"./sign-railroad-fill.svg": [
		55501,
		[
			55501
		]
	],
	"./sign-railroad.svg": [
		7033,
		[
			7033
		]
	],
	"./sign-stop-fill.svg": [
		39391,
		[
			39391
		]
	],
	"./sign-stop-lights-fill.svg": [
		90396,
		[
			90396
		]
	],
	"./sign-stop-lights.svg": [
		74275,
		[
			74275
		]
	],
	"./sign-stop.svg": [
		12243,
		[
			12243
		]
	],
	"./sign-turn-left-fill.svg": [
		51022,
		[
			51022
		]
	],
	"./sign-turn-left.svg": [
		94364,
		[
			94364
		]
	],
	"./sign-turn-right-fill.svg": [
		44239,
		[
			44239
		]
	],
	"./sign-turn-right.svg": [
		26019,
		[
			26019
		]
	],
	"./sign-turn-slight-left-fill.svg": [
		7738,
		[
			7738
		]
	],
	"./sign-turn-slight-left.svg": [
		82096,
		[
			82096
		]
	],
	"./sign-turn-slight-right-fill.svg": [
		91459,
		[
			91459
		]
	],
	"./sign-turn-slight-right.svg": [
		59295,
		[
			59295
		]
	],
	"./sign-yield-fill.svg": [
		1472,
		[
			1472
		]
	],
	"./sign-yield.svg": [
		63662,
		[
			63662
		]
	],
	"./signal.svg": [
		11569,
		[
			11569
		]
	],
	"./signpost-2-fill.svg": [
		30345,
		[
			30345
		]
	],
	"./signpost-2.svg": [
		51005,
		[
			51005
		]
	],
	"./signpost-fill.svg": [
		71834,
		[
			71834
		]
	],
	"./signpost-split-fill.svg": [
		74483,
		[
			74483
		]
	],
	"./signpost-split.svg": [
		20527,
		[
			20527
		]
	],
	"./signpost.svg": [
		27984,
		[
			27984
		]
	],
	"./sim-fill.svg": [
		30592,
		[
			30592
		]
	],
	"./sim-slash-fill.svg": [
		38160,
		[
			38160
		]
	],
	"./sim-slash.svg": [
		3454,
		[
			3454
		]
	],
	"./sim.svg": [
		63598,
		[
			63598
		]
	],
	"./sina-weibo.svg": [
		21465,
		[
			21465
		]
	],
	"./skip-backward-btn-fill.svg": [
		71305,
		[
			71305
		]
	],
	"./skip-backward-btn.svg": [
		83165,
		[
			83165
		]
	],
	"./skip-backward-circle-fill.svg": [
		91223,
		[
			91223
		]
	],
	"./skip-backward-circle.svg": [
		62971,
		[
			62971
		]
	],
	"./skip-backward-fill.svg": [
		61923,
		[
			84304
		]
	],
	"./skip-backward.svg": [
		37118,
		[
			37118
		]
	],
	"./skip-end-btn-fill.svg": [
		68567,
		[
			68567
		]
	],
	"./skip-end-btn.svg": [
		42011,
		[
			42011
		]
	],
	"./skip-end-circle-fill.svg": [
		25133,
		[
			25133
		]
	],
	"./skip-end-circle.svg": [
		63353,
		[
			63353
		]
	],
	"./skip-end-fill.svg": [
		42398,
		[
			42398
		]
	],
	"./skip-end.svg": [
		35820,
		[
			35820
		]
	],
	"./skip-forward-btn-fill.svg": [
		31959,
		[
			31959
		]
	],
	"./skip-forward-btn.svg": [
		13499,
		[
			13499
		]
	],
	"./skip-forward-circle-fill.svg": [
		74189,
		[
			74189
		]
	],
	"./skip-forward-circle.svg": [
		45689,
		[
			45689
		]
	],
	"./skip-forward-fill.svg": [
		5118,
		[
			5118
		]
	],
	"./skip-forward.svg": [
		80236,
		[
			80236
		]
	],
	"./skip-start-btn-fill.svg": [
		41402,
		[
			41402
		]
	],
	"./skip-start-btn.svg": [
		28176,
		[
			28176
		]
	],
	"./skip-start-circle-fill.svg": [
		85502,
		[
			85502
		]
	],
	"./skip-start-circle.svg": [
		96908,
		[
			96908
		]
	],
	"./skip-start-fill.svg": [
		55763,
		[
			55763
		]
	],
	"./skip-start.svg": [
		94223,
		[
			94223
		]
	],
	"./skype.svg": [
		90709,
		[
			90709
		]
	],
	"./slack.svg": [
		84359,
		[
			84359
		]
	],
	"./slash-circle-fill.svg": [
		75125,
		[
			75125
		]
	],
	"./slash-circle.svg": [
		50993,
		[
			50993
		]
	],
	"./slash-lg.svg": [
		62274,
		[
			62274
		]
	],
	"./slash-square-fill.svg": [
		63958,
		[
			63958
		]
	],
	"./slash-square.svg": [
		94004,
		[
			94004
		]
	],
	"./slash.svg": [
		54980,
		[
			54980
		]
	],
	"./sliders.svg": [
		99745,
		[
			99745
		]
	],
	"./sliders2-vertical.svg": [
		60912,
		[
			60912
		]
	],
	"./sliders2.svg": [
		6561,
		[
			6561
		]
	],
	"./smartwatch.svg": [
		46093,
		[
			46093
		]
	],
	"./snapchat.svg": [
		55527,
		[
			55527
		]
	],
	"./snow.svg": [
		29208,
		[
			29208
		]
	],
	"./snow2.svg": [
		49914,
		[
			49914
		]
	],
	"./snow3.svg": [
		68971,
		[
			68971
		]
	],
	"./sort-alpha-down-alt.svg": [
		24225,
		[
			24225
		]
	],
	"./sort-alpha-down.svg": [
		76047,
		[
			76047
		]
	],
	"./sort-alpha-up-alt.svg": [
		98006,
		[
			98006
		]
	],
	"./sort-alpha-up.svg": [
		34976,
		[
			34976
		]
	],
	"./sort-down-alt.svg": [
		67772,
		[
			67772
		]
	],
	"./sort-down.svg": [
		45958,
		[
			45958
		]
	],
	"./sort-numeric-down-alt.svg": [
		3834,
		[
			3834
		]
	],
	"./sort-numeric-down.svg": [
		12380,
		[
			12380
		]
	],
	"./sort-numeric-up-alt.svg": [
		37270,
		[
			37270
		]
	],
	"./sort-numeric-up.svg": [
		18391,
		[
			18391
		]
	],
	"./sort-up-alt.svg": [
		17479,
		[
			17479
		]
	],
	"./sort-up.svg": [
		54250,
		[
			54250
		]
	],
	"./soundwave.svg": [
		6353,
		[
			6353
		]
	],
	"./sourceforge.svg": [
		7179,
		[
			7179
		]
	],
	"./speaker-fill.svg": [
		55738,
		[
			55738
		]
	],
	"./speaker.svg": [
		87792,
		[
			87792
		]
	],
	"./speedometer.svg": [
		44504,
		[
			44504
		]
	],
	"./speedometer2.svg": [
		87130,
		[
			87130
		]
	],
	"./spellcheck.svg": [
		18427,
		[
			18427
		]
	],
	"./spotify.svg": [
		94505,
		[
			94505
		]
	],
	"./square-fill.svg": [
		98958,
		[
			98958
		]
	],
	"./square-half.svg": [
		21138,
		[
			21138
		]
	],
	"./square.svg": [
		26684,
		[
			26684
		]
	],
	"./stack-overflow.svg": [
		69258,
		[
			69258
		]
	],
	"./stack.svg": [
		57407,
		[
			57407
		]
	],
	"./star-fill.svg": [
		94185,
		[
			94185
		]
	],
	"./star-half.svg": [
		12913,
		[
			12913
		]
	],
	"./star.svg": [
		61309,
		[
			61309
		]
	],
	"./stars.svg": [
		31860,
		[
			31860
		]
	],
	"./steam.svg": [
		91763,
		[
			91763
		]
	],
	"./stickies-fill.svg": [
		60850,
		[
			60850
		]
	],
	"./stickies.svg": [
		49016,
		[
			49016
		]
	],
	"./sticky-fill.svg": [
		9566,
		[
			9566
		]
	],
	"./sticky.svg": [
		6636,
		[
			6636
		]
	],
	"./stop-btn-fill.svg": [
		37884,
		[
			37884
		]
	],
	"./stop-btn.svg": [
		27762,
		[
			27762
		]
	],
	"./stop-circle-fill.svg": [
		8728,
		[
			8728
		]
	],
	"./stop-circle.svg": [
		90358,
		[
			90358
		]
	],
	"./stop-fill.svg": [
		74445,
		[
			74445
		]
	],
	"./stop.svg": [
		98297,
		[
			98297
		]
	],
	"./stoplights-fill.svg": [
		70576,
		[
			70576
		]
	],
	"./stoplights.svg": [
		83614,
		[
			83614
		]
	],
	"./stopwatch-fill.svg": [
		78392,
		[
			78392
		]
	],
	"./stopwatch.svg": [
		68022,
		[
			68022
		]
	],
	"./strava.svg": [
		37516,
		[
			37516
		]
	],
	"./stripe.svg": [
		88774,
		[
			66393
		]
	],
	"./subscript.svg": [
		21104,
		[
			21104
		]
	],
	"./substack.svg": [
		43427,
		[
			43427
		]
	],
	"./subtract.svg": [
		55061,
		[
			55061
		]
	],
	"./suit-club-fill.svg": [
		47619,
		[
			47619
		]
	],
	"./suit-club.svg": [
		47455,
		[
			47455
		]
	],
	"./suit-diamond-fill.svg": [
		10329,
		[
			10329
		]
	],
	"./suit-diamond.svg": [
		40621,
		[
			40621
		]
	],
	"./suit-heart-fill.svg": [
		51773,
		[
			51773
		]
	],
	"./suit-heart.svg": [
		23625,
		[
			23625
		]
	],
	"./suit-spade-fill.svg": [
		82088,
		[
			82088
		]
	],
	"./suit-spade.svg": [
		17574,
		[
			17574
		]
	],
	"./suitcase-fill.svg": [
		96052,
		[
			96052
		]
	],
	"./suitcase-lg-fill.svg": [
		93314,
		[
			93314
		]
	],
	"./suitcase-lg.svg": [
		88040,
		[
			88040
		]
	],
	"./suitcase.svg": [
		36026,
		[
			36026
		]
	],
	"./suitcase2-fill.svg": [
		89798,
		[
			89798
		]
	],
	"./suitcase2.svg": [
		88484,
		[
			88484
		]
	],
	"./sun-fill.svg": [
		7925,
		[
			7925
		]
	],
	"./sun.svg": [
		66929,
		[
			66929
		]
	],
	"./sunglasses.svg": [
		8863,
		[
			8863
		]
	],
	"./sunrise-fill.svg": [
		40076,
		[
			40076
		]
	],
	"./sunrise.svg": [
		40258,
		[
			40258
		]
	],
	"./sunset-fill.svg": [
		56647,
		[
			56647
		]
	],
	"./sunset.svg": [
		9707,
		[
			9707
		]
	],
	"./superscript.svg": [
		12327,
		[
			12327
		]
	],
	"./symmetry-horizontal.svg": [
		53519,
		[
			75900
		]
	],
	"./symmetry-vertical.svg": [
		91722,
		[
			91722
		]
	],
	"./table.svg": [
		70671,
		[
			70671
		]
	],
	"./tablet-fill.svg": [
		84757,
		[
			84757
		]
	],
	"./tablet-landscape-fill.svg": [
		40049,
		[
			40049
		]
	],
	"./tablet-landscape.svg": [
		80437,
		[
			80437
		]
	],
	"./tablet.svg": [
		80561,
		[
			80561
		]
	],
	"./tag-fill.svg": [
		12903,
		[
			12903
		]
	],
	"./tag.svg": [
		43723,
		[
			43723
		]
	],
	"./tags-fill.svg": [
		55340,
		[
			55340
		]
	],
	"./tags.svg": [
		92578,
		[
			92578
		]
	],
	"./taxi-front-fill.svg": [
		1175,
		[
			1175
		]
	],
	"./taxi-front.svg": [
		88187,
		[
			88187
		]
	],
	"./telegram.svg": [
		91380,
		[
			91380
		]
	],
	"./telephone-fill.svg": [
		75543,
		[
			75543
		]
	],
	"./telephone-forward-fill.svg": [
		22671,
		[
			22671
		]
	],
	"./telephone-forward.svg": [
		39683,
		[
			39683
		]
	],
	"./telephone-inbound-fill.svg": [
		95703,
		[
			95703
		]
	],
	"./telephone-inbound.svg": [
		79899,
		[
			79899
		]
	],
	"./telephone-minus-fill.svg": [
		84030,
		[
			84030
		]
	],
	"./telephone-minus.svg": [
		23468,
		[
			23468
		]
	],
	"./telephone-outbound-fill.svg": [
		68586,
		[
			68586
		]
	],
	"./telephone-outbound.svg": [
		72512,
		[
			72512
		]
	],
	"./telephone-plus-fill.svg": [
		71782,
		[
			71782
		]
	],
	"./telephone-plus.svg": [
		56484,
		[
			56484
		]
	],
	"./telephone-x-fill.svg": [
		80502,
		[
			80502
		]
	],
	"./telephone-x.svg": [
		33172,
		[
			33172
		]
	],
	"./telephone.svg": [
		18299,
		[
			18299
		]
	],
	"./tencent-qq.svg": [
		36731,
		[
			36731
		]
	],
	"./terminal-dash.svg": [
		52666,
		[
			52666
		]
	],
	"./terminal-fill.svg": [
		68553,
		[
			68553
		]
	],
	"./terminal-plus.svg": [
		89238,
		[
			89238
		]
	],
	"./terminal-split.svg": [
		39210,
		[
			39210
		]
	],
	"./terminal-x.svg": [
		66934,
		[
			66934
		]
	],
	"./terminal.svg": [
		1597,
		[
			1597
		]
	],
	"./text-center.svg": [
		50666,
		[
			50666
		]
	],
	"./text-indent-left.svg": [
		4855,
		[
			4855
		]
	],
	"./text-indent-right.svg": [
		65298,
		[
			65298
		]
	],
	"./text-left.svg": [
		73278,
		[
			73278
		]
	],
	"./text-paragraph.svg": [
		83925,
		[
			83925
		]
	],
	"./text-right.svg": [
		35101,
		[
			35101
		]
	],
	"./text-wrap.svg": [
		2281,
		[
			2281
		]
	],
	"./textarea-resize.svg": [
		95984,
		[
			95984
		]
	],
	"./textarea-t.svg": [
		90820,
		[
			90820
		]
	],
	"./textarea.svg": [
		28031,
		[
			28031
		]
	],
	"./thermometer-half.svg": [
		14579,
		[
			14579
		]
	],
	"./thermometer-high.svg": [
		35740,
		[
			35740
		]
	],
	"./thermometer-low.svg": [
		49310,
		[
			49310
		]
	],
	"./thermometer-snow.svg": [
		30969,
		[
			30969
		]
	],
	"./thermometer-sun.svg": [
		99450,
		[
			99450
		]
	],
	"./thermometer.svg": [
		58359,
		[
			58359
		]
	],
	"./threads-fill.svg": [
		57861,
		[
			80242
		]
	],
	"./threads.svg": [
		39320,
		[
			39320
		]
	],
	"./three-dots-vertical.svg": [
		18763,
		[
			18763
		]
	],
	"./three-dots.svg": [
		42488,
		[
			42488
		]
	],
	"./thunderbolt-fill.svg": [
		3030,
		[
			3030
		]
	],
	"./thunderbolt.svg": [
		17556,
		[
			17556
		]
	],
	"./ticket-detailed-fill.svg": [
		6096,
		[
			6096
		]
	],
	"./ticket-detailed.svg": [
		98878,
		[
			98878
		]
	],
	"./ticket-fill.svg": [
		18109,
		[
			18109
		]
	],
	"./ticket-perforated-fill.svg": [
		35698,
		[
			35698
		]
	],
	"./ticket-perforated.svg": [
		82360,
		[
			82360
		]
	],
	"./ticket.svg": [
		64617,
		[
			64617
		]
	],
	"./tiktok.svg": [
		58207,
		[
			58207
		]
	],
	"./toggle-off.svg": [
		33897,
		[
			33897
		]
	],
	"./toggle-on.svg": [
		38101,
		[
			38101
		]
	],
	"./toggle2-off.svg": [
		25233,
		[
			25233
		]
	],
	"./toggle2-on.svg": [
		49565,
		[
			49565
		]
	],
	"./toggles.svg": [
		68364,
		[
			68364
		]
	],
	"./toggles2.svg": [
		41910,
		[
			41910
		]
	],
	"./tools.svg": [
		3910,
		[
			3910
		]
	],
	"./tornado.svg": [
		41580,
		[
			41580
		]
	],
	"./train-freight-front-fill.svg": [
		74665,
		[
			74665
		]
	],
	"./train-freight-front.svg": [
		40061,
		[
			40061
		]
	],
	"./train-front-fill.svg": [
		72187,
		[
			72187
		]
	],
	"./train-front.svg": [
		43687,
		[
			43687
		]
	],
	"./train-lightrail-front-fill.svg": [
		66898,
		[
			66898
		]
	],
	"./train-lightrail-front.svg": [
		47416,
		[
			47416
		]
	],
	"./translate.svg": [
		50417,
		[
			50417
		]
	],
	"./transparency.svg": [
		7431,
		[
			7431
		]
	],
	"./trash-fill.svg": [
		35945,
		[
			35945
		]
	],
	"./trash.svg": [
		35005,
		[
			35005
		]
	],
	"./trash2-fill.svg": [
		8241,
		[
			8241
		]
	],
	"./trash2.svg": [
		43253,
		[
			43253
		]
	],
	"./trash3-fill.svg": [
		68406,
		[
			68406
		]
	],
	"./trash3.svg": [
		81972,
		[
			81972
		]
	],
	"./tree-fill.svg": [
		24937,
		[
			24937
		]
	],
	"./tree.svg": [
		5373,
		[
			5373
		]
	],
	"./trello.svg": [
		27263,
		[
			27263
		]
	],
	"./triangle-fill.svg": [
		66121,
		[
			66121
		]
	],
	"./triangle-half.svg": [
		25201,
		[
			25201
		]
	],
	"./triangle.svg": [
		55037,
		[
			55037
		]
	],
	"./trophy-fill.svg": [
		54667,
		[
			54667
		]
	],
	"./trophy.svg": [
		4023,
		[
			4023
		]
	],
	"./tropical-storm.svg": [
		3681,
		[
			3681
		]
	],
	"./truck-flatbed.svg": [
		5343,
		[
			5343
		]
	],
	"./truck-front-fill.svg": [
		96238,
		[
			96238
		]
	],
	"./truck-front.svg": [
		72975,
		[
			95356
		]
	],
	"./truck.svg": [
		80594,
		[
			80594
		]
	],
	"./tsunami.svg": [
		2166,
		[
			2166
		]
	],
	"./tux.svg": [
		43448,
		[
			43448
		]
	],
	"./tv-fill.svg": [
		44815,
		[
			44815
		]
	],
	"./tv.svg": [
		59491,
		[
			59491
		]
	],
	"./twitch.svg": [
		82624,
		[
			82624
		]
	],
	"./twitter-x.svg": [
		94545,
		[
			94545
		]
	],
	"./twitter.svg": [
		92746,
		[
			92746
		]
	],
	"./type-bold.svg": [
		52399,
		[
			52399
		]
	],
	"./type-h1.svg": [
		9159,
		[
			9159
		]
	],
	"./type-h2.svg": [
		37652,
		[
			37652
		]
	],
	"./type-h3.svg": [
		82581,
		[
			82581
		]
	],
	"./type-h4.svg": [
		27306,
		[
			27306
		]
	],
	"./type-h5.svg": [
		69275,
		[
			69275
		]
	],
	"./type-h6.svg": [
		87912,
		[
			87912
		]
	],
	"./type-italic.svg": [
		24770,
		[
			24770
		]
	],
	"./type-strikethrough.svg": [
		73371,
		[
			73371
		]
	],
	"./type-underline.svg": [
		23730,
		[
			23730
		]
	],
	"./type.svg": [
		51145,
		[
			51145
		]
	],
	"./typescript.svg": [
		76348,
		[
			76348
		]
	],
	"./ubuntu.svg": [
		8192,
		[
			8192
		]
	],
	"./ui-checks-grid.svg": [
		68624,
		[
			68624
		]
	],
	"./ui-checks.svg": [
		20551,
		[
			20551
		]
	],
	"./ui-radios-grid.svg": [
		52637,
		[
			52637
		]
	],
	"./ui-radios.svg": [
		35908,
		[
			35908
		]
	],
	"./umbrella-fill.svg": [
		48405,
		[
			48405
		]
	],
	"./umbrella.svg": [
		89777,
		[
			89777
		]
	],
	"./unindent.svg": [
		48526,
		[
			48526
		]
	],
	"./union.svg": [
		6014,
		[
			6014
		]
	],
	"./unity.svg": [
		7472,
		[
			7472
		]
	],
	"./universal-access-circle.svg": [
		53680,
		[
			53680
		]
	],
	"./universal-access.svg": [
		72595,
		[
			72595
		]
	],
	"./unlock-fill.svg": [
		51565,
		[
			51565
		]
	],
	"./unlock.svg": [
		84185,
		[
			84185
		]
	],
	"./unlock2-fill.svg": [
		47677,
		[
			47677
		]
	],
	"./unlock2.svg": [
		6793,
		[
			6793
		]
	],
	"./upc-scan.svg": [
		5073,
		[
			5073
		]
	],
	"./upc.svg": [
		22317,
		[
			22317
		]
	],
	"./upload.svg": [
		35106,
		[
			35106
		]
	],
	"./usb-c-fill.svg": [
		5661,
		[
			5661
		]
	],
	"./usb-c.svg": [
		77065,
		[
			77065
		]
	],
	"./usb-drive-fill.svg": [
		75748,
		[
			75748
		]
	],
	"./usb-drive.svg": [
		29898,
		[
			29898
		]
	],
	"./usb-fill.svg": [
		55557,
		[
			55557
		]
	],
	"./usb-micro-fill.svg": [
		99172,
		[
			99172
		]
	],
	"./usb-micro.svg": [
		71306,
		[
			71306
		]
	],
	"./usb-mini-fill.svg": [
		92979,
		[
			92979
		]
	],
	"./usb-mini.svg": [
		74351,
		[
			74351
		]
	],
	"./usb-plug-fill.svg": [
		6536,
		[
			6536
		]
	],
	"./usb-plug.svg": [
		14118,
		[
			14118
		]
	],
	"./usb-symbol.svg": [
		94934,
		[
			94934
		]
	],
	"./usb.svg": [
		88929,
		[
			88929
		]
	],
	"./valentine.svg": [
		47953,
		[
			47953
		]
	],
	"./valentine2.svg": [
		88785,
		[
			88785
		]
	],
	"./vector-pen.svg": [
		54038,
		[
			54038
		]
	],
	"./view-list.svg": [
		63783,
		[
			63783
		]
	],
	"./view-stacked.svg": [
		82806,
		[
			82806
		]
	],
	"./vignette.svg": [
		63983,
		[
			63983
		]
	],
	"./vimeo.svg": [
		52575,
		[
			52575
		]
	],
	"./vinyl-fill.svg": [
		87335,
		[
			87335
		]
	],
	"./vinyl.svg": [
		8203,
		[
			8203
		]
	],
	"./virus.svg": [
		96868,
		[
			96868
		]
	],
	"./virus2.svg": [
		66718,
		[
			66718
		]
	],
	"./voicemail.svg": [
		97904,
		[
			97904
		]
	],
	"./volume-down-fill.svg": [
		87262,
		[
			87262
		]
	],
	"./volume-down.svg": [
		52780,
		[
			52780
		]
	],
	"./volume-mute-fill.svg": [
		78927,
		[
			78927
		]
	],
	"./volume-mute.svg": [
		18915,
		[
			18915
		]
	],
	"./volume-off-fill.svg": [
		10595,
		[
			10595
		]
	],
	"./volume-off.svg": [
		94943,
		[
			94943
		]
	],
	"./volume-up-fill.svg": [
		16763,
		[
			16763
		]
	],
	"./volume-up.svg": [
		89607,
		[
			89607
		]
	],
	"./vr.svg": [
		30469,
		[
			30469
		]
	],
	"./wallet-fill.svg": [
		3436,
		[
			3436
		]
	],
	"./wallet.svg": [
		8610,
		[
			8610
		]
	],
	"./wallet2.svg": [
		1052,
		[
			1052
		]
	],
	"./watch.svg": [
		94862,
		[
			94862
		]
	],
	"./water.svg": [
		39534,
		[
			39534
		]
	],
	"./webcam-fill.svg": [
		10864,
		[
			10864
		]
	],
	"./webcam.svg": [
		89566,
		[
			89566
		]
	],
	"./wechat.svg": [
		69935,
		[
			69935
		]
	],
	"./whatsapp.svg": [
		75087,
		[
			75087
		]
	],
	"./wifi-1.svg": [
		52592,
		[
			52592
		]
	],
	"./wifi-2.svg": [
		41987,
		[
			41987
		]
	],
	"./wifi-off.svg": [
		36290,
		[
			36290
		]
	],
	"./wifi.svg": [
		59506,
		[
			59506
		]
	],
	"./wikipedia.svg": [
		24142,
		[
			24142
		]
	],
	"./wind.svg": [
		29215,
		[
			29215
		]
	],
	"./window-dash.svg": [
		93918,
		[
			93918
		]
	],
	"./window-desktop.svg": [
		91998,
		[
			91998
		]
	],
	"./window-dock.svg": [
		28879,
		[
			28879
		]
	],
	"./window-fullscreen.svg": [
		51205,
		[
			51205
		]
	],
	"./window-plus.svg": [
		15778,
		[
			15778
		]
	],
	"./window-sidebar.svg": [
		87658,
		[
			87658
		]
	],
	"./window-split.svg": [
		38446,
		[
			38446
		]
	],
	"./window-stack.svg": [
		88126,
		[
			88126
		]
	],
	"./window-x.svg": [
		79194,
		[
			79194
		]
	],
	"./window.svg": [
		76297,
		[
			76297
		]
	],
	"./windows.svg": [
		2984,
		[
			2984
		]
	],
	"./wordpress.svg": [
		642,
		[
			642
		]
	],
	"./wrench-adjustable-circle-fill.svg": [
		63295,
		[
			63295
		]
	],
	"./wrench-adjustable-circle.svg": [
		70208,
		[
			70208
		]
	],
	"./wrench-adjustable.svg": [
		88918,
		[
			88918
		]
	],
	"./wrench.svg": [
		37006,
		[
			37006
		]
	],
	"./x-circle-fill.svg": [
		57506,
		[
			57506
		]
	],
	"./x-circle.svg": [
		64296,
		[
			64296
		]
	],
	"./x-diamond-fill.svg": [
		83082,
		[
			83082
		]
	],
	"./x-diamond.svg": [
		864,
		[
			864
		]
	],
	"./x-lg.svg": [
		42839,
		[
			42839
		]
	],
	"./x-octagon-fill.svg": [
		78697,
		[
			78697
		]
	],
	"./x-octagon.svg": [
		78141,
		[
			78141
		]
	],
	"./x-square-fill.svg": [
		61525,
		[
			61525
		]
	],
	"./x-square.svg": [
		6302,
		[
			83921
		]
	],
	"./x.svg": [
		94251,
		[
			94251
		]
	],
	"./xbox.svg": [
		83962,
		[
			83962
		]
	],
	"./yelp.svg": [
		99327,
		[
			99327
		]
	],
	"./yin-yang.svg": [
		22691,
		[
			22691
		]
	],
	"./youtube.svg": [
		75856,
		[
			75856
		]
	],
	"./zoom-in.svg": [
		30896,
		[
			30896
		]
	],
	"./zoom-out.svg": [
		40207,
		[
			40207
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 1 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 59145;
module.exports = webpackAsyncContext;